'use strict';

angular.module('qlikApp',
    ['qlikObject',
        'ui.bootstrap',
        'helpers',
        'qlikLayout',
        'qlikWidgetHelpers',
        'qlikVisualizationHelpers'
    ]);

/**
 * @ngdoc directive
 * @name qlikApp.qlikAppMaps
 * @restrict E
 * @description
 *
 * Opens a Qlik application, gets a lists of visualization displays them on the screen
 * Note: Qlik tickets are currently retrieved from localstorage.
 *
 * Usage:
 * <qlik-app-maps></qlik-app-maps>
 *
 */

'use strict';

angular.module('qlikApp')
    .component('qlikAppMaps', {
        templateUrl: 'app/components/qlikApp/qlikMaps/qlikMaps.html',
        binding: {},
        transclude: true,
        controllerAs: 'qlikMaps',
        controller: function ($rootScope, $scope, $timeout, $q, $document, $location, $window, qlikAppService, qlikVisualizations, localStorageHelpers) {
            var self = this;
            var legend = function () {
                return $window.angular.element('.qv-discrete-color-legend');
            };
            var legendHandle;
            var windowContext = qlikAppService.getIframeContextDetails($window);
            var state = JSON.parse(localStorageHelpers.getState($window));
            var productCodes = [];

            self.maps = [];
            self.visualization = qlikAppService.getWidgetGroupsForContext(
                windowContext.vertical,
                windowContext.appType,
                windowContext.market
            );

            var products = JSON.parse(localStorageHelpers.getProducts($window));
            var productCodeHash = {};
            angular.forEach(self.visualization.maps, function (map) {
                if (products[map.productName]) {
                    if (!productCodeHash[map.productCode]) {
                        productCodeHash[map.productCode] = 1;
                        productCodes.push({
                            qText: map.productCode
                        });
                    }
                    self.maps.push(map);
                }
            });

            /**
             * @type Qlik App Helper
             * @description Clears user applied filters but retains system / locked filters
             */
            self.resetMap = function () {
                $rootScope.qlikApp.selectionState().clearAll(false);
                self.switchMap(self.selectedMap);
            };

            /**
             * @type Qlik App Helper
             * @description Switches the "Applied Map" filter within the visualization
             * @param {obejct } map - map object representing the new map-config to apply
             */
            self.switchMap = function (map) {
                self.selectedMap = map;
                $rootScope.qlikApp.field('Market_ID').selectValues([qlikVisualizations.markets[windowContext.specificMarket].id], false, false);
                $rootScope.qlikApp.field('MapName').selectValues([{ qText: map.mapName }], false, false);
                $rootScope.qlikApp.field('MapProductCode').selectValues(productCodes, false, false);
                $rootScope.qlikApp.field('State').selectValues([{ qText: state }], false, false);
            };

            /**
             * @type Qlik App Helper
             * @private
             * @description triggers a redraw of the legend which Qlik sometimes ignores during window resize
             */
            var touchLegend = function () {
                legendHandle = legend();
                $timeout(function () {
                    legendHandle[0].style.display = 'none';
                    legendHandle[0].style.display = 'inline-flex';
                }, 0);
            };

            var watcher = $scope.$watch(
                function () {
                    return legend().length;
                },
                function (newValue, oldValue) {
                    if (newValue === oldValue) {
                        return;
                    }
                    if (newValue > 0) {
                        touchLegend();
                        watcher();
                    }
                }
            );

            self.$onInit = function () {
                if ($rootScope.qlikApp) {
                    if ($scope.qlikMaps.visualization && $scope.qlikMaps.visualization.maps[0]) {
                        $scope.qlikMaps.switchMap($scope.qlikMaps.visualization.maps[0]);
                    }
                }
            };
        }
    });

'use strict';

/**
 * @ngdoc service
 * @name qlikApp.qlikWidgetExportService
 * @restrict E
 * @description
 *
 * Contains methods to aid with exporting Qlik visualizations
 *
 */
angular.module('qlikApp')
    .factory('qlikWidgetExportService', function () {
        /**
         * @name replaceInvalidFileNameChars
         * @param {string} fileName
         * @param {string} replacementString
         * @description Replaces invalid file name characters from a string.
         * | & ; $ % @ " < > ( ) + ,
         */
        var replaceInvalidFileNameChars = function (fileName, replacementString) {
            var invalidChars = /[|&;$%@"<>()+,]/g; // \|&;\$%@"<>\(\)\+,
            return fileName.replace(invalidChars, replacementString);
        };

        /**
         * @name getDataModelLayoutTitle
         * @param {object} dataModel
         * @description Returns a visualization's title layout title property or null.
         */
        var getDataModelLayoutTitle = function (dataModel) {
            return (dataModel
                && dataModel.layout
                && dataModel.layout.title
                && typeof dataModel.layout.title === 'string'
                && dataModel.layout.title.trim())
                || null;
        };

        /**
         * @name getDataModelPropertyTitle
         * @param {object} dataModel
         * @description Returns a visualization's title properties title property or null.
         * @private
         */
        var getDataModelPropertyTitle = function (dataModel) {
            return (dataModel
                && dataModel.properties
                && dataModel.properties.title
                && typeof dataModel.properties.title === 'string'
                && dataModel.properties.title.trim())
                || null;
        };

        /**
         * @name getDataModelTitle
         * @param {object} dataModel
         * @description Gets a visualizations title from its datamodel object.
         * @private
         */
        var getDataModelTitle = function (dataModel) {
            return getDataModelLayoutTitle(dataModel) || getDataModelPropertyTitle(dataModel) || dataModel.id;
        };

        /**
         * @name getFileName
         * @param {object} dataModel
         * @description Gets a visualizations export file name by using the title and date stamp.
         */
        var getFileName = function (dataModel) {
            var title = getDataModelTitle(dataModel);

            var now = new Date();
            var timestamp = [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('-');

            return replaceInvalidFileNameChars(title + ' ' + timestamp, '');
        };

        return {
            replaceInvalidFileNameChars: replaceInvalidFileNameChars,
            getDataModelLayoutTitle: getDataModelLayoutTitle,
            getDataModelPropertyTitle: getDataModelPropertyTitle,
            getDataModelTitle: getDataModelTitle,
            getFileName: getFileName
        };
    });

/**
 * @ngdoc directive
 * @name qlikApp.qlikAppWidgets
 * @restrict E
 * @description
 *
 * Opens a Qlik application, gets a lists of visualization displays them on the screen
 * Note: Qlik tickets are currently retrieved from localstorage.
 *
 * Usage:
 * <qlik-app-widgets></qlik-app-widgets>
 *
 */

'use strict';

angular.module('qlikApp')
    .directive('qlikAppWidgets', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/components/qlikApp/qlikWidgets/qlikWidgets.html',
            controllerAs: 'qlikWidgets',
            controller: function (
                $rootScope,
                $scope,
                $document,
                $timeout,
                $window,
                $q,
                localStorageHelpers,
                qlikAppConfig,
                appConfig,
                qlikAppService,
                qlikVisualizationsService,
                qlikWidgetHelpersService,
                qlikWidgetExportService
            ) {
                $scope.isKpi = $rootScope.isKpi;
                $scope.isForecast = $rootScope.isForecast;
                $scope.visualizations = qlikAppService.getWidgetGroupsForContext(
                    $rootScope.windowContext.vertical,
                    $rootScope.windowContext.appType,
                    $rootScope.windowContext.market
                );

                /**
                 * @description Passes error event information up out of the nested qlik-frame iframe
                 * @param {any} message
                 * @param {error} err
                 * @todo CONSOLIDATE THIS CODE INTO THE QLIKAPPSERVICE FUNCTION
                 */
                var emitFromNavbar = function (message, err) {
                    $window.parent.angular.element('dude-navigation').scope().$emit(message, err);
                };

                // REGION : Visualization Export / View Modification
                /**
                 * @description Collects and then saves all necessary data for the exporting of a widget to image format
                 * @param {object} canvas - canvas object
                 * @param {object} data - represents the playload to render into blob
                 */
                var deliverBlob = function (canvas, data) {
                    return $q(function (resolve) {
                        data.elements.forEach = Array.prototype.forEach;
                        data.loaders.forEach = Array.prototype.forEach;
                        data.elements.forEach(function (element) {
                            element.classList.remove('hidden');
                        });

                        data.loaders.forEach(function (element) {
                            element.classList.remove('hidden');
                        });

                        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
                        if (isIE11) {
                            var image = canvas.toDataURL();
                            image = image.replace(/^data:[a-z]*;,/, '');
                            image = image.split('base64,')[1];

                            // Convert from base64 to an ArrayBuffer
                            var byteString = window.atob(image);
                            var buffer = new window.ArrayBuffer(byteString.length);
                            var intArray = new window.Uint8Array(buffer);
                            for (var i = 0; i < byteString.length; i++) {
                                intArray[i] = byteString.charCodeAt(i);
                            }

                            // Use the native blob constructor
                            var newBlob = new Blob([buffer], { type: 'image/png' });

                            // Download this blob
                            window.navigator.msSaveOrOpenBlob(newBlob, data.filename);
                            resolve(true);
                        } else {
                            canvas.toBlob(function (blob) {
                                resolve(saveAs(blob, data.filename)); // eslint-disable-line
                            });
                        }
                    });
                };

                /**
                 * @name saveToImage
                 * @param {$event} event emitted
                 * @param {item} Qlik GenericObject.
                 * @description Saves object to a png.
                 * (refer to src/app/qlikObject)
                 */
                $scope.saveToImage = function ($event, objectId) {
                    var filename = objectId;
                    var idx;
                    var id = ($scope.activeItem) ? 'full-view' : objectId;
                    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
                    var widget = $window.document.getElementById(id);
                    var titleDiv = widget.querySelector('.qv-object-title-text');
                    titleDiv = (!titleDiv || !titleDiv.innerText) ? widget.querySelector('.measure-title') : titleDiv;

                    if (titleDiv && titleDiv.innerText) {
                        titleDiv.innerText = titleDiv.innerText.trim();
                        filename = titleDiv.innerText;
                    }

                    var loaders = widget.querySelectorAll('[ng-style="loaderStyle"]');
                    for (idx = 0; idx < loaders.length; idx++) {
                        loaders[idx].classList.add('hidden');
                    }

                    var title = widget.querySelector('.measure-title');
                    if (title) {
                        if (isIE11 && title.style && !title.style.width) {
                            title.style.width = ((title.offsetWidth + title.parentNode.offsetWidth) / 2) + 'px';
                            title.style.margin = '0 auto';
                        }
                    }

                    var centered = widget.querySelectorAll('.qva-chart-data-title-rotate');
                    for (idx = 0; idx < centered.length; idx++) {
                        centered[idx].innerText = centered[idx].innerText.trim().replace(/[\s]+/gi, ' ');
                    }

                    var elements = widget.getElementsByClassName('ng-hide');
                    for (idx = 0; idx < elements.length; idx++) {
                        elements[idx].classList.add('hidden');
                    }

                    filename = filename.replace(/[\s]/gi, '_').toLowerCase() + '.png';
                    // emit event up to navbar

                    var imageComponents = {
                        loaders: loaders,
                        elements: elements,
                        widgetId: id,
                        filename: filename
                    };

                    emitFromNavbar('showSpinner', imageComponents);
                };

                /**
                 * @name toggleFullSize
                 * @param {Object} $event emitted
                 * @param {int} itemId ID of the Qlik GenericObject
                 * @param {boolean} refuseImage Boolean informing the widget doesn't support image export.
                 * @param {boolean} refuseCSV Boolean informing the widget doesn't support CSV export.
                 * @description toggles the isolated view experience for a given visualization. It is important to note
                 * that once `self.activeItem` is set, Qlik Angular is asynchronously injecting html into an element there
                 * (refer to src/app/qlikObject)
                 */
                $scope.toggleFullSize = function ($event, itemId, refuseImage, refuseCSV) {
                    $scope.activeItem = itemId;
                    $scope.refuseImage = refuseImage;
                    $scope.refuseCSV = refuseCSV;

                    if (itemId) {
                        return;
                    }
                    $timeout(function () {
                        $window.parent.document.getElementById('qlik-frame').height = $window.parent.document.getElementById('qlik-frame').height = $window.angular.element($document).height();
                    }, qlikAppConfig.timeouts.collection);
                };

                /**
                 *   This event is emitted from the promise return of a qlikObject load. Unfortunately the promise returned from that stage is simply if the Qlik
                 *  Angular object received the GenericObject from the Qlik Repository, that promise is resolved BEFORE it beings to
                 *  inject the GenericObject's structure. Thus a timeout is required before we redraw the iframe height.
                 */
                $rootScope.$on('single-render', function () {
                    $timeout(function () {
                        var domElements = {
                            header: $window.parent.document.getElementsByClassName('main-nav').length > 0 ? $window.parent.document.getElementsByClassName('main-nav')[0].offsetHeight : 0,
                            pageTitle: $window.parent.document.getElementsByClassName('page-title').length > 0 ? $window.parent.document.getElementsByClassName('page-title')[0].offsetHeight : 0,
                            parentWindow: $window.parent.innerHeight
                        };
                        $window.parent.document.getElementById('qlik-frame').height = qlikWidgetHelpersService.adjustHeight(domElements);
                    }, qlikAppConfig.timeouts.individual);
                });

                /**
                 * @name exportCSV
                 * @param {string} objectId
                 * @description Exports a visualizations data
                 */
                $scope.exportCSV = function (objectId) {
                    var userId = $window.localStorage['dsi.userId'];
                    var userDirectory = 'DUDEPLATFORM';

                    return $rootScope.qlikApp.getObject(objectId, objectId).then(function (dataModel) {
                        var fileName = qlikWidgetExportService.getFileName(dataModel);
                        var tempTable = new $window.qlikNativeObj.table(dataModel); // eslint-disable-line new-cap
                        return tempTable.exportData({ download: false, format: 0, filename: fileName }, function (xlsURI) {
                            var fileUri = 'https://' + appConfig.settings.qlikServerUri + xlsURI;
                            var qlikthenticatorExportUri = appConfig.api.qlikthenticator + '/export?url=' + encodeURIComponent(fileUri) + '&name=' + encodeURIComponent(fileName) + '&userId=' + encodeURIComponent(userId) + '&userDirectory=' + encodeURIComponent(userDirectory);

                            var link = $window.angular.element('<a></a>')[0];
                            link.download = fileName + '.xlsx';
                            link.href = qlikthenticatorExportUri;
                            $window.angular.element('body').append(link);
                            link.click();
                            link.remove();

                            emitFromNavbar('dudeLog:XLSXportSuccess');
                        });
                    }, function (err) {
                        emitFromNavbar('dudelog:XLSXportFailure', err);
                    });
                };
                // END REGION

                // REGION Qlik App State Modifiers
                $scope.clearFilters = function () {
                    return $rootScope.qlikApp.clearAll();
                };
                // END REGION

                // REGION : Event Handlers
                $rootScope.$on('spinnerShowing', function (event, data) {
                    $window.html2canvas(document.getElementById(data.widgetId))
                        .then(function (canvas) {
                            return deliverBlob(canvas, data);
                        })
                        .then(function () {
                            return emitFromNavbar('hideSpinner');
                        });
                });
                // END REGION
            }
        };
    });

'use strict';

angular.module('qlikApp')
    .component('qlikDashWidget', {
        bindings: {
            app: '<',
            widgetName: '<',
            widgetHeight: '<'
        },
        templateUrl: 'app/components/qlikApp/qlikDash/qlikDashWidget.html',
        controllerAs: 'qlikDashWidget',
        controller: function () {
            var self = this;

            self.$onInit = function () {
                self.displayStyle = {
                    height: self.widgetHeight
                };
                self.app.getObject(self.widgetName, self.widgetName)
                    .catch(function () {
                        // TODO: error handling placeholder
                    });
            };
        }
    });

'use strict';

angular.module('qlikApp')
    .component('qlikDash', {
        bindings: {},
        templateUrl: 'app/components/qlikApp/qlikDash/qlikDash.html',
        controllerAs: 'qlikDash',
        controller: function ($q, $scope, $rootScope, $window, qlikAppService, commonMappings, qlikLayoutService) {
            var self = this;
            self.widgetGridHeight = commonMappings.Display.qlikFrame.qlikDashWidgetGrid.height;
            self.widgetGridWidth = commonMappings.Display.qlikFrame.qlikDashWidgetGrid.width;

            self.graphicsRowStyle = {
                display: 'inline-block',
                position: 'relative',
                height: (self.widgetGridHeight + 'px'),
                width: self.widgetGridWidth
            };

            /**
             * @private
             * @type State Management
             * @description sets the activeSheet state
             * @param {object} sheet
             */
            var setActiveSheet = function (sheet) {
                self.activeSheet = sheet;
            };

            /**
             * @private
             * @type State Management
             * @param {array{object} widgets - collection of widgets
             * @returns {Promise<any>}
             */
            var setActiveWidgets = function (widgets) {
                return $q.all(widgets)
                    .then(function (sheetWidgets) {
                        self.filterBar = sheetWidgets.filterBar;
                        self.graphics = sheetWidgets.graphics;
                    });
            };

            self.setWidgetHeight = function (decimalHeight) {
                return (commonMappings.Display.qlikFrame.qlikDashWidgetGrid.height * decimalHeight) + 'px';
            };

            // REGION: General Init
            self.$onInit = function () {
                // establish all related sheets
                var sheetPromises = qlikAppService.getAppSheets(
                    $rootScope.qlikApp,
                    $rootScope.windowContext.vertical,
                    $rootScope.windowContext.appType,
                    $rootScope.marketGroup
                );

                $q.all(sheetPromises)
                    .then(function (sheetsResult) {
                        if (sheetsResult.length < 1) {
                            // throw here
                        }
                        setActiveSheet(sheetsResult[0]);
                        self.allSheets = sheetsResult;
                        return qlikAppService.getSheetLayout(self.activeSheet);
                    })
                    // TODO: is this redundant and needs to be in one function?
                    .then(function (sheetDataModel) {
                        self.gridWidth = sheetDataModel.columns;
                        self.gridHeight = sheetDataModel.rows;
                        return {
                            filterBar: sheetDataModel.filterBar,
                            graphics: qlikLayoutService.generateDisplayObject(sheetDataModel.rows, sheetDataModel.columns, sheetDataModel.graphics, sheetDataModel.filterBar.length)
                        };
                    })
                    .then(function (allSheetWidgets) {
                        return setActiveWidgets(allSheetWidgets);
                    })
                    .catch(function () {
                        // throw here
                    });

                // REGION : Event Handlers
                $rootScope.$on(commonMappings.Events.QLIK_APP_SWITCH_SHEET, function (event, data) {
                    qlikAppService.getObjectFromApp($rootScope.qlikApp, data.id)
                        .then(function (sheet) {
                            setActiveSheet(sheet);
                            return qlikAppService.getSheetLayout(self.activeSheet);
                        })
                        .then(function (sheetDataModel) {
                            self.gridWidth = sheetDataModel.columns;
                            self.gridHeight = sheetDataModel.rows;
                            return {
                                filterBar: sheetDataModel.filterBar,
                                graphics: qlikLayoutService.generateDisplayObject(sheetDataModel.rows, sheetDataModel.columns, sheetDataModel.graphics, sheetDataModel.filterBar.length)
                            };
                        })
                        .then(function (allSheetWidgets) {
                            return setActiveWidgets(allSheetWidgets);
                        })
                        .catch(function () {
                            // throw here
                        });
                });
                // END REGION
            };
            // END REGION
        }
    });

'use strict';

angular.module('qlikApp')
    .component('filterPane', {
        bindings: {
            app: '<',
            widgetId: '@'
        },
        templateUrl: 'app/components/qlikApp/filterPane/filterPane.html',
        controllerAs: 'filterPane',
        controller: function ($window) {
            var self = this;
            var fieldCount = 0;
            var resizeInterval;
            /**
             * @private
             * @type calculation helper
             * @description calculates a value, uses a magic number to accomplish this
             * @param {integer} quantity - number of elements we need to consider
             * @param {columns available}
             * @returns {integer} resulted value
             *
             * @todo: address magic number (44) in DINT-626
             */
            var computeNewHeight = function (quantity, columnsAvailable) {
                var delta = quantity - columnsAvailable;
                switch (delta) {
                case (0) : return 44;
                case (1) : return 44 * 2;
                default : return 44 * delta;
                }
            };

            /**
             * @private
             * @type Window Scraper
             * @description Detects if a filterpane has a scrollable element present
             * @returns {integer} - returns a non-zero value if the filter-pane element contains the
             * 'qv-filterpane-scrollable' class
             */
            var scrollingPresent = function () {
                return angular.element('.qv-filterpane-scrollable').length;
            };

            /**
             * @private
             * @type Window helper
             * @description Qlik adds a "scrolling" area to widgets when their encapsulating div isnt large
             * enough to display the wiget in its entirety. We're solving this js instead of css because
             * the necessary height of the element is relative to the number of filters within the widget.
             */
            var resizeHandler = function () {
                if (!scrollingPresent()) {
                    return;
                }
                var elementToEffect = angular.element('qv-filterpane').first();
                var columnsToConsider = angular.element('qv-filterpane .qv-filterpane-column').length;
                var newHeight = computeNewHeight(fieldCount, columnsToConsider);
                elementToEffect.height(newHeight);
            };

            self.$onInit = function () {
                self.app.getObject(self.widgetId, self.widgetId)
                    .then(function (result) {
                        fieldCount = result.layout.qChildList.qItems.length;
                        resizeInterval = $window.setInterval(function () {
                            resizeHandler();
                        }, 1500);
                    })
                    .catch(function () {
                        // TODO: Error handling placeholder
                    });
            };

            self.$onDestroy = function () {
                $window.clearInterval(resizeInterval);
            };
        }
    });

'use strict';

angular.module('qlikObject', []);

/**
 * @ngdoc directive
 * @name qlikObject.qlikObject
 * @restrict A
 * @description
 *
 * Displays a Qlik App Object by its object ID
 *
 * @param {Object} objectId The Qlik object id
 * @param {boolean | string} fullSize is the object being presented as a full-sized visualization or not(optional)
 *
 * Usage:
 * <div qlik-object object-id={object} (full-size='true')></div>
 *
 */

'use strict';

angular.module('qlikObject')
    .directive('qlikObject', function ($rootScope) {
        return {
            restrict: 'A',
            scope: {
                objectId: '=qlikObject',
                fullSize: '=?'
            },
            link: function (scope, element) {
                var targetId = (scope.fullSize) ? 'full-view' : scope.objectId;
                element.attr('id', targetId);
                // Keep selections/interaction turned off for KPIs; on for Trends, etc.
                var options = $rootScope.isKpi ? { noSelections: true } : undefined;

                $rootScope.qlikApp.getObject(targetId, scope.objectId, options).then(function () {
                    if (scope.fullSize) {
                        $rootScope.$emit('single-render', scope.fullSize);
                    }
                });
            }
        };
    });

'use strict';

angular.module('qlikWidgetHelpers', []);

/**
 * @ngdoc service
 * @name qlikApp.qlikWidgetHelpers.qlikWidgetHelpersService
 *
 * @description
 * Service for assisting with the manipulation of qlikWidgets (generic objects)
 *
 */

'use strict';
angular.module('qlikWidgetHelpers')
    .service('qlikWidgetHelpersService', function () {
        /**
         * @ngdoc method
         * @name adjustHeight
         * @methodOf qlikApp.qlikWidgetHelpers.qlikWidgetHelpersService
         * @param {Object} elementSizing comprised of pre-computed sizes of several dom elements
         * @description
         * Used to compute available visual real estate, minus the Dude Platform Header(header and main nav)
         * and the current page's h1
         *
         * @returns {int} value of available real estate
         */
        var adjustHeight = function (elementSizing) {
            return elementSizing.parentWindow - (elementSizing.header + elementSizing.pageTitle);
        };
        return {
            adjustHeight: adjustHeight
        };
    });

'use strict';

angular.module('qlikVisualizationHelpers', []);

/**
 * @ngdoc service
 * @name qlikForm.qlikVisualizationsService
 *
 * @description
 * Service for building the visualizations array for specified route and market.
 *
 */

'use strict';
angular.module('qlikVisualizationHelpers')
    .service('qlikVisualizationsService', function (qlikVisualizations) {
        var getVisualizationsAtRoute = function (routeParam) {
            var routeParts = routeParam.substring(1).split('/');
            return routeParts.reduce(function (current, part) {
                if (current) {
                    return current[part];
                }
                return null;
            }, qlikVisualizations.layouts);
        };

        /**
         * @ngdoc method
         * @name get
         * @methodOf qlikForm.qlikVisualizationsService
         * @description
         * A method used to get an array of visualizations for route and market.
         *
         * @param {object} routeParam page route
         * @param {object} marketId market name
         * @returns {Array} visualizations array
         */
        var getVisualizations = function (routeParam, marketId) {
            var visualizationsAtRoute = getVisualizationsAtRoute(routeParam);

            if (visualizationsAtRoute && qlikVisualizations.markets[marketId]) {
                var marketGroup = qlikVisualizations.markets[marketId].marketGroup;
                return visualizationsAtRoute[marketGroup] ? visualizationsAtRoute[marketGroup] : visualizationsAtRoute.nonEducation;
            }

            // route not defined in visualizations
            return [];
        };

        /**
         * @ngdoc method
         * @name get
         * @methodOf qlikForm.qlikVisualizationsService
         * @description
         * A method used to get an Qlik Application Id for route.
         *
         * @param {object} routeParam page route
         * @returns {object} Qlik Application Id
         */
        var getApplicationName = function (routeParam) {
            var visualizationsAtRoute = getVisualizationsAtRoute(routeParam);
            if (visualizationsAtRoute) {
                return visualizationsAtRoute.app;
            }

            // route not defined in visualizations
            return null;
        };

        return {
            getVisualizations: getVisualizations,
            getApplicationName: getApplicationName,
            getVisualizationsAtRoute: getVisualizationsAtRoute
        };
    });

'use strict';

// Categories are not translated any more since we would have to include the
// 3rd party library for translation and that would cause us to load the vendor.js/bower dependencies
// which would then cause the double angular load issue.
// TODO: Fix translation when we not longer use the iFrame.

angular.module('qlikVisualizationHelpers')
    .constant('qlikVisualizations', {
        markets: {
            k12: { marketGroup: 'education', id: 6 },
            he: { marketGroup: 'education', id: 7 },
            ips: { marketGroup: 'education', id: 8 },
            mfg: { marketGroup: 'manufacturing', id: 4 },
            gov: { marketGroup: 'government', id: 2 },
            club: { marketGroup: 'membership', id: 1 },
            fdother: { marketGroup: 'others', id: 5 }
        },
        layouts: {
            maintenance: {
                kpis: {
                    app: 'maintenance',
                    education: [
                        {
                            app: 'kpi',
                            category: 'Volume',
                            widgets: [
                                { objectId: 'hxSnAem', cssClass: 'col-md-6 qlik-widget-xs', refuseImage: true },
                                { objectId: 'eEmukGV', cssClass: 'col-md-6 qlik-widget-xs', refuseImage: true },
                                { objectId: 'Jsjpa', cssClass: 'col-md-12' },
                                { objectId: 'eXqJNs', cssClass: 'col-md-6 qlik-widget-lg' },
                                { objectId: 'HBynpCM', tableId: 'QZPAx', cssClass: 'col-md-6' },
                                { objectId: 'SDXvKH', tableId: 'ZYuKPy', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'yYrtKv', tableId: 'FgkUJQk', cssClass: 'col-md-12' },
                                { objectId: 'qkmmJ', tableId: 'PpBVts', cssClass: 'col-md-12' },
                                { objectId: 'bbPps', tableId: 'cfdUY', cssClass: 'col-md-12' },
                                { objectId: 'yYSWfLY', tableId: 'HqpCvG', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            app: 'kpi',
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'dbSX', tableId: 'WGzHtMD', cssClass: 'col-md-6' },
                                { objectId: 'muWXfFQ', tableId: 'pJMSR', cssClass: 'col-md-6' },
                                { objectId: 'deZMmP', cssClass: 'col-md-12' },
                                { objectId: 'XaJhkT', tableId: 'jAXJZZ', cssClass: 'col-md-12' },
                                { objectId: 'pGyfkK', tableId: 'kXpGJ', cssClass: 'col-md-12' },
                                { objectId: 'Vrc', cssClass: 'col-md-12' },
                                { objectId: 'rEYSsJc', cssClass: 'col-md-12' },
                                { objectId: 'AzJVJk', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            app: 'kpi',
                            category: 'Data Quality',
                            widgets: [
                                { objectId: 'hTmQkcP', cssClass: 'col-md-12' }
                            ]
                        }
                    ],
                    nonEducation: [
                        {
                            app: 'kpi',
                            category: 'Volume',
                            widgets: [
                                { objectId: 'hxSnAem', cssClass: 'col-md-6 qlik-widget-xs', refuseImage: true },
                                { objectId: 'eEmukGV', cssClass: 'col-md-6 qlik-widget-xs', refuseImage: true },
                                { objectId: 'bc2c0ab6-4c4c-4acc-9143-c1e8c92a2dbc', cssClass: 'col-md-12' },
                                { objectId: 'eXqJNs', cssClass: 'col-md-6 qlik-widget-lg' },
                                { objectId: 'HBynpCM', tableId: 'QZPAx', cssClass: 'col-md-6' },
                                { objectId: 'SDXvKH', tableId: 'ZYuKPy', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'yYrtKv', tableId: 'FgkUJQk', cssClass: 'col-md-12' },
                                { objectId: 'qkmmJ', tableId: 'PpBVts', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            app: 'kpi',
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'deZMmP', cssClass: 'col-md-12' },
                                { objectId: 'dbSX', tableId: 'WGzHtMD', cssClass: 'col-md-12' },
                                { objectId: 'XaJhkT', tableId: 'jAXJZZ', cssClass: 'col-md-12' },
                                { objectId: 'muWXfFQ', tableId: 'pJMSR', cssClass: 'col-md-12' },
                                { objectId: 'pGyfkK', tableId: 'kXpGJ', cssClass: 'col-md-12' },
                                { objectId: 'Vrc', cssClass: 'col-md-6' },
                                { objectId: 'rEYSsJc', cssClass: 'col-md-6' },
                                { objectId: 'AzJVJk', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            app: 'kpi',
                            category: 'Data Quality',
                            widgets: [
                                { objectId: 'hTmQkcP', cssClass: 'col-md-12' }
                            ]
                        }
                    ]
                },
                forecast: {
                    app: 'forecast',
                    education: [
                        {
                            app: 'forecast',
                            category: 'education',
                            widgets: [
                                { objectId: 'ENntrj', cssClass: 'col-md-12 qlik-widget-xxs', refuseImage: true, refuseCSV: true },
                                { objectId: '9e0fdb4d-2507-48da-9eac-a8b4114b8391', cssClass: 'col-md-12 qlik-widget-xs' },
                                { objectId: '425635c3-e63d-47fc-9485-257ea4a916d8', cssClass: 'col-md-12 qlik-widget-md' },
                                { objectId: 'e5ac23cb-bec4-4370-819b-a04f410b5ae4', cssClass: 'col-md-12 qlik-widget-xs' },
                                { objectId: '283f7dd1-3b72-416c-8908-f2a9508b76fb', cssClass: 'col-md-12 qlik-widget-md' },
                                { objectId: '8ca99fa8-9a12-4436-8c3e-65013b107c38', cssClass: 'col-md-12 qlik-widget-sm' }

                            ]
                        }
                    ],
                    nonEducation: [
                        {
                            app: 'forecast',
                            category: 'nonEducation',
                            widgets: [
                                { objectId: 'ENntrj', cssClass: 'col-md-12 qlik-widget-xxs', refuseImage: true, refuseCSV: true },
                                { objectId: '9e0fdb4d-2507-48da-9eac-a8b4114b8391', cssClass: 'col-md-12 qlik-widget-xs' },
                                { objectId: '425635c3-e63d-47fc-9485-257ea4a916d8', cssClass: 'col-md-12 qlik-widget-md' },
                                { objectId: 'e5ac23cb-bec4-4370-819b-a04f410b5ae4', cssClass: 'col-md-12 qlik-widget-xs' },
                                { objectId: '283f7dd1-3b72-416c-8908-f2a9508b76fb', cssClass: 'col-md-12 qlik-widget-md' },
                                { objectId: '8ca99fa8-9a12-4436-8c3e-65013b107c38', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        }
                    ]
                },
                trends: {
                    app: 'maintenance',
                    education: [
                        {
                            category: '',
                            app: 'trends',
                            widgets: [
                                { objectId: 'RLKHuQ', cssClass: 'col-md-12' },
                                { objectId: 'zFvmAb', cssClass: 'col-md-12' },
                                { objectId: 'fyEwmpd', cssClass: 'col-md-12' },
                                { objectId: 'QJLbjU', cssClass: 'col-md-12' },
                                { objectId: 'Bptb', cssClass: 'col-md-12' },
                                { objectId: 'FvUNwZw', cssClass: 'col-md-12' },
                                { objectId: 'bgjCdn', cssClass: 'col-md-12' },
                                { objectId: 'NNuYmS', cssClass: 'col-md-12' },
                                { objectId: 'rpbvMu', cssClass: 'col-md-12' },
                                { objectId: 'gbxjWu', cssClass: 'col-md-12' },
                                { objectId: 'MmNzTR', cssClass: 'col-md-12' },
                                { objectId: 'Hqpkt', cssClass: 'col-md-12' },
                                { objectId: 'eCdhPM', cssClass: 'col-md-12' },
                                { objectId: 'qWfkZ', cssClass: 'col-md-12' },
                                { objectId: 'SmNcg', cssClass: 'col-md-12' },
                                { objectId: 'YCRKVdp', cssClass: 'col-md-12' },
                                { objectId: 'TNnn', cssClass: 'col-md-12' },
                                { objectId: 'VKVYze', cssClass: 'col-md-12' },
                                { objectId: 'qQWmvYB', cssClass: 'col-md-12' }
                            ]
                        }
                    ],
                    nonEducation: [
                        {
                            app: 'trends',
                            category: '',
                            widgets: [
                                { objectId: 'RLKHuQ', cssClass: 'col-md-12' },
                                { objectId: 'zFvmAb', cssClass: 'col-md-12' },
                                { objectId: 'fyEwmpd', cssClass: 'col-md-12' },
                                { objectId: 'QJLbjU', cssClass: 'col-md-12' },
                                { objectId: 'Bptb', cssClass: 'col-md-12' },
                                { objectId: 'FvUNwZw', cssClass: 'col-md-12' },
                                { objectId: 'bgjCdn', cssClass: 'col-md-12' },
                                { objectId: 'NNuYmS', cssClass: 'col-md-12' },
                                { objectId: 'rpbvMu', cssClass: 'col-md-12' },
                                { objectId: 'gbxjWu', cssClass: 'col-md-12' },
                                { objectId: 'MmNzTR', cssClass: 'col-md-12' },
                                { objectId: 'Hqpkt', cssClass: 'col-md-12' },
                                { objectId: 'eCdhPM', cssClass: 'col-md-12' },
                                { objectId: 'qWfkZ', cssClass: 'col-md-12' },
                                { objectId: 'SmNcg', cssClass: 'col-md-12' },
                                { objectId: 'YCRKVdp', cssClass: 'col-md-12' },
                                { objectId: 'TNnn', cssClass: 'col-md-12' },
                                { objectId: 'VKVYze', cssClass: 'col-md-12' },
                                { objectId: 'qQWmvYB', cssClass: 'col-md-12' }
                            ]
                        }
                    ]
                },
                dashboard: {
                    education: {
                        app: 'education',
                        sheets: [
                            { name: 'Dashboard: Assigned To', id: 'GbUgJ', url: 'https://intelligence-master.dudesoln.com/sense/app/9dde58f3-2d52-4255-af0b-df08bc4ffda1/sheet/GbUgJ/state/analysis?id=' },
                            { name: 'Dashboard: Location', id: 'cca4a9bf-2e0c-4202-bec7-192fa2a48b78', url: 'https://intelligence-master.dudesoln.com/sense/app/9dde58f3-2d52-4255-af0b-df08bc4ffda1/sheet/cca4a9bf-2e0c-4202-bec7-192fa2a48b78/state/analysis?id=' },
                            { name: 'Dashboard: Craft', id: 'dd767efa-5652-4c78-8cc7-a2a522baf973', url: 'https://intelligence-master.dudesoln.com/sense/app/9dde58f3-2d52-4255-af0b-df08bc4ffda1/sheet/dd767efa-5652-4c78-8cc7-a2a522baf973/state/analysis?id=' },
                            { name: 'Dashboard: Open Heat Map #1', id: '13d9792f-72e2-497a-938b-882b8529365f', url: 'https://intelligence-master.dudesoln.com/sense/app/9dde58f3-2d52-4255-af0b-df08bc4ffda1/sheet/13d9792f-72e2-497a-938b-882b8529365f/state/analysis?id=' },
                            { name: 'Dashboard: Open Heat Map #2', id: 'Ujmrtp', url: 'https://intelligence-master.dudesoln.com/sense/app/9dde58f3-2d52-4255-af0b-df08bc4ffda1/sheet/Ujmrtp/state/analysis?id=' },
                            { name: 'Dashboard: On-Time Completion', id: 'ecXmPSv', url: 'https://intelligence-master.dudesoln.com/sense/app/9dde58f3-2d52-4255-af0b-df08bc4ffda1/sheet/ecXmPSv/state/analysis?id=' },
                            { name: 'Dashboard: Class/Type Cost', id: '556a88a1-0038-47da-9055-d7cf840c9089', url: 'https://intelligence-master.dudesoln.com/sense/app/9dde58f3-2d52-4255-af0b-df08bc4ffda1/sheet/556a88a1-0038-47da-9055-d7cf840c9089/state/analysis?id=' }
                        ]
                    },
                    manufacturing: {
                        app: 'manufacturing',
                        sheets: [
                            { name: 'Dashboard: Employee', id: 'GbUgJ', url: 'https://intelligence-master.dudesoln.com/sense/app/f744f8c4-527b-4d48-a1af-5d1f3505da2a/sheet/GbUgJ/state/analysis?id=' },
                            { name: 'Dashboard: Location', id: 'cca4a9bf-2e0c-4202-bec7-192fa2a48b78', url: 'https://intelligence-master.dudesoln.com/sense/app/f744f8c4-527b-4d48-a1af-5d1f3505da2a/sheet/cca4a9bf-2e0c-4202-bec7-192fa2a48b78/state/analysis?id=' },
                            { name: 'Dashboard: On-Time Completion', id: 'ecXmPSv', url: 'https://intelligence-master.dudesoln.com/sense/app/f744f8c4-527b-4d48-a1af-5d1f3505da2a/sheet/ecXmPSv/state/analysis?id=' },
                            { name: 'Dashboard: Equipment', id: '556a88a1-0038-47da-9055-d7cf840c9089', url: 'https://intelligence-master.dudesoln.com/sense/app/f744f8c4-527b-4d48-a1af-5d1f3505da2a/sheet/556a88a1-0038-47da-9055-d7cf840c9089/state/analysis?id=' },
                            { name: 'Dashboard: Open Heat Map', id: '13d9792f-72e2-497a-938b-882b8529365f', url: 'https://intelligence-master.dudesoln.com/sense/app/f744f8c4-527b-4d48-a1af-5d1f3505da2a/sheet/13d9792f-72e2-497a-938b-882b8529365f/state/analysis?id=' },
                            { name: 'Dashboard: Downtime', id: 'Ujmrtp', url: 'https://intelligence-master.dudesoln.com/sense/app/f744f8c4-527b-4d48-a1af-5d1f3505da2a/sheet/Ujmrtp/state/analysis?id=' },
                            { name: 'Dashboard: Mean-Time-To-Repair', id: 'nSrjZFn', url: 'https://intelligence-master.dudesoln.com/sense/app/f744f8c4-527b-4d48-a1af-5d1f3505da2a/sheet/nSrjZFn/state/analysis?id=' }
                        ]
                    },
                    government: {
                        app: 'government',
                        sheets: [
                            { name: 'Dashboard: Assigned To', id: 'GbUgJ', url: 'https://intelligence-master.dudesoln.com/sense/app/e244cb81-8237-4d30-81aa-d1af8dd83c50/sheet/GbUgJ/state/analysis?id=' },
                            { name: 'Dashboard: Location', id: 'cca4a9bf-2e0c-4202-bec7-192fa2a48b78', url: 'https://intelligence-master.dudesoln.com/sense/app/e244cb81-8237-4d30-81aa-d1af8dd83c50/sheet/cca4a9bf-2e0c-4202-bec7-192fa2a48b78/state/analysis?id=' },
                            { name: 'Dashboard: Craft', id: 'dd767efa-5652-4c78-8cc7-a2a522baf973', url: 'https://intelligence-master.dudesoln.com/sense/app/e244cb81-8237-4d30-81aa-d1af8dd83c50/sheet/dd767efa-5652-4c78-8cc7-a2a522baf973/state/analysis?id=' },
                            { name: 'Dashboard: Open Heat Map #1', id: '13d9792f-72e2-497a-938b-882b8529365f', url: 'https://intelligence-master.dudesoln.com/sense/app/e244cb81-8237-4d30-81aa-d1af8dd83c50/sheet/13d9792f-72e2-497a-938b-882b8529365f/state/analysis?id=' },
                            { name: 'Dashboard: Open Heat Map #2', id: 'Ujmrtp', url: 'https://intelligence-master.dudesoln.com/sense/app/e244cb81-8237-4d30-81aa-d1af8dd83c50/sheet/Ujmrtp/state/analysis?id=' },
                            { name: 'Dashboard: On-Time Completion', id: 'ecXmPSv', url: 'https://intelligence-master.dudesoln.com/sense/app/e244cb81-8237-4d30-81aa-d1af8dd83c50/sheet/ecXmPSv/state/analysis?id=' },
                            { name: 'Dashboard: Class/Type Cost', id: '556a88a1-0038-47da-9055-d7cf840c9089', url: 'https://intelligence-master.dudesoln.com/sense/app/e244cb81-8237-4d30-81aa-d1af8dd83c50/sheet/556a88a1-0038-47da-9055-d7cf840c9089/state/analysis?id=' }
                        ]
                    },
                    membership: {
                        app: 'membership',
                        sheets: [
                            { name: 'Dashboard: Assigned To', id: 'GbUgJ', url: 'https://intelligence-master.dudesoln.com/sense/app/ccd12553-b794-4021-89db-a698dd6cc8d2/sheet/GbUgJ/state/analysis?id=' },
                            { name: 'Dashboard: Location', id: 'cca4a9bf-2e0c-4202-bec7-192fa2a48b78', url: 'https://intelligence-master.dudesoln.com/sense/app/ccd12553-b794-4021-89db-a698dd6cc8d2/sheet/cca4a9bf-2e0c-4202-bec7-192fa2a48b78/state/analysis?id=' },
                            { name: 'Dashboard: Craft', id: 'dd767efa-5652-4c78-8cc7-a2a522baf973', url: 'https://intelligence-master.dudesoln.com/sense/app/ccd12553-b794-4021-89db-a698dd6cc8d2/sheet/dd767efa-5652-4c78-8cc7-a2a522baf973/state/analysis?id=' },
                            { name: 'Dashboard: Open Heat Map #1', id: '13d9792f-72e2-497a-938b-882b8529365f', url: 'https://intelligence-master.dudesoln.com/sense/app/ccd12553-b794-4021-89db-a698dd6cc8d2/sheet/13d9792f-72e2-497a-938b-882b8529365f/state/analysis?id=' },
                            { name: 'Dashboard: Open Heat Map #2', id: 'Ujmrtp', url: 'https://intelligence-master.dudesoln.com/sense/app/ccd12553-b794-4021-89db-a698dd6cc8d2/sheet/Ujmrtp/state/analysis?id=' },
                            { name: 'Dashboard: On-Time Completion', id: 'ecXmPSv', url: 'https://intelligence-master.dudesoln.com/sense/app/ccd12553-b794-4021-89db-a698dd6cc8d2/sheet/ecXmPSv/state/analysis?id=' },
                            { name: 'Dashboard: Class/Type Cost', id: '556a88a1-0038-47da-9055-d7cf840c9089', url: 'https://intelligence-master.dudesoln.com/sense/app/ccd12553-b794-4021-89db-a698dd6cc8d2/sheet/556a88a1-0038-47da-9055-d7cf840c9089/state/analysis?id=' }
                        ]
                    },
                    others: {
                        app: 'others',
                        sheets: [
                            { name: 'Dashboard: Assigned To', id: 'GbUgJ' },
                            { name: 'Dashboard: Location', id: 'cca4a9bf-2e0c-4202-bec7-192fa2a48b78' },
                            { name: 'Dashboard: Craft', id: 'dd767efa-5652-4c78-8cc7-a2a522baf973' },
                            { name: 'Dashboard: Open Heat Map #1', id: '13d9792f-72e2-497a-938b-882b8529365f' },
                            { name: 'Dashboard: Open Heat Map #2', id: 'Ujmrtp' },
                            { name: 'Dashboard: On-Time Completion', id: 'ecXmPSv' },
                            { name: 'Dashboard: Class/Type Cost', id: '556a88a1-0038-47da-9055-d7cf840c9089' }
                        ]
                    }
                },
                maps: {
                    app: 'maps',
                    education: {
                        category: 'Maps',
                        mapObjectId: 'a70a375b-1719-4985-9940-2fa657cf4411',
                        maps: [
                            { mapName: '% of WOs Completed < Week', productName: 'MaintenanceDirect', productCode: 'MD' },
                            { mapName: 'WOs Per Student Per Year', productName: 'MaintenanceDirect', productCode: 'MD' },
                            { mapName: 'Avg Days Aged Open Work', productName: 'MaintenanceDirect', productCode: 'MD' },
                            { mapName: 'Avg Days To Complete CM', productName: 'MaintenanceDirect', productCode: 'MD' },
                            { mapName: '% WOs Entered by Requesters', productName: 'MaintenanceDirect', productCode: 'MD' },
                            { mapName: 'Avg WOs Per Employee Per Yr', productName: 'MaintenanceDirect', productCode: 'MD' },
                            { mapName: 'Avg Hours Per Employee Per Week', productName: 'MaintenanceDirect', productCode: 'MD' },
                            { mapName: '% of Completed WOs as PM', productName: 'PMDirect', productCode: 'PMD' },
                            { mapName: '% of Completed PMs < Month', productName: 'PMDirect', productCode: 'PMD' },
                            { mapName: 'Avg Days To Complete PMs', productName: 'PMDirect', productCode: 'PMD' }
                        ]
                    }
                }
            },
            events: {
                dashboard: {
                    education: {
                        app: 'events',
                        sheets: [
                            { name: 'Dashboard: Location', id: '8665366b-7822-4b69-a913-9d84f8b6ac75' },
                            { name: 'Dashboard: Organization', id: '3920a203-4254-4695-a49c-8137e27a12d8' },
                            { name: 'Dashboard: Organization Type', id: '1b2b930b-3fd8-467e-a65e-b302bdfea87e' },
                            { name: 'Dashboard: Event Services', id: 'QkCjre' },
                            { name: 'Dashboard: Buildings', id: '7124f064-819c-4259-a50f-eb2fad8d4e15' }
                        ]
                    }
                },
                kpis: {
                    app: 'events',
                    education: [
                        {
                            app: 'kpi',
                            category: 'Volume',
                            widgets: [
                                { objectId: 'LwkGH', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'pkCwm', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'pHgmen', tableId: 'suWBbjH', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'ucWqL', tableId: 'zvfDDJ', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'VJjpM', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'WeTJstu', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'AmtxN', tableId: 'wNhaWmZ', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        },
                        {
                            app: 'kpi',
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'jjkG', tableId: 'vRaqKJb', cssClass: 'col-md-12' },
                                { objectId: 'dgTMqh', tableId: 'pjAx', cssClass: 'col-md-12' },
                                { objectId: 'VJTfPq', tableId: 'snVuQ', cssClass: 'col-md-12' },
                                { objectId: 'JuMZURe', tableId: 'NNQLFju', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'PjGQdzV', cssClass: 'col-md-12' },
                                { objectId: 'pLejYvu', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            app: 'kpi',
                            category: 'Cost',
                            widgets: [
                                { objectId: 'YVnjWh', tableId: 'SSdrZ', cssClass: 'col-md-12' },
                                { objectId: 'GYAxFR', cssClass: 'col-md-12' },
                                { objectId: 'pXytdqK', cssClass: 'col-md-12' },
                                { objectId: 'JFxGRP', tableId: 'abbJJJV', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'TKZH', tableId: 'pENcPYx', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        }
                    ]
                },
                trends: {
                    app: 'events',
                    education: [
                        {
                            app: 'trends',
                            category: '',
                            widgets: [
                                { objectId: 'BLKuDKZ', cssClass: 'col-md-12' },
                                { objectId: 'aKDUah', cssClass: 'col-md-12' },
                                { objectId: 'XTASxL', cssClass: 'col-md-12' },
                                { objectId: 'HZNyb', cssClass: 'col-md-12' },
                                { objectId: 'MmrTjNQ', cssClass: 'col-md-12' },
                                { objectId: 'JzpZmJp', cssClass: 'col-md-12' },
                                { objectId: 'kDQYSPd', cssClass: 'col-md-12' },
                                { objectId: 'YyNPZ', cssClass: 'col-md-12' },
                                { objectId: 'TSKPUPv', cssClass: 'col-md-12' },
                                { objectId: 'kGZhD', cssClass: 'col-md-12' },
                                { objectId: 'jNGPKv', cssClass: 'col-md-12' },
                                { objectId: 'MknXQ', cssClass: 'col-md-12' },
                                { objectId: 'PVPJy', cssClass: 'col-md-12' }
                            ]
                        }
                    ]
                },
                maps: {
                    app: 'maps',
                    education: {
                        category: 'Maps',
                        mapObjectId: 'a70a375b-1719-4985-9940-2fa657cf4411',
                        maps: [
                            {
                                mapName: 'Events Per Student Per Year',
                                productName: 'FSDirect',
                                productCode: 'FSD'
                            },
                            {
                                mapName: '% of Event Requests by Requesters',
                                productName: 'FSDirect',
                                productCode: 'FSD'
                            },
                            {
                                mapName: '% of Event Requests by Community',
                                productName: 'FSDirect',
                                productCode: 'FSD'
                            },
                            {
                                mapName: 'Avg Days to Activate Permits',
                                productName: 'FSDirect',
                                productCode: 'FSD'
                            },
                            {
                                mapName: '$ Invoiced Per Student Per Year',
                                productName: 'FSDirect',
                                productCode: 'FSD'
                            },
                            { mapName: '% of Invoices Paid', productName: 'FSDirect', productCode: 'FSD' },
                            { mapName: '% of Invoices Overdue', productName: 'FSDirect', productCode: 'FSD' }
                        ]
                    }
                }
            },
            utilities: {
                kpis: {
                    app: 'energy',
                    education: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'LtgN', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'pLZta', tableId: 'BvVmA', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'WRbvmK', tableId: 'XKCmT', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'gaEch', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'PMgNP', tableId: 'TafmdRZ', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'jmSmBZ', tableId: 'VHpMXm', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'PjwqJBf', cssClass: 'col-md-6' },
                                { objectId: 'rXEgxn', cssClass: 'col-md-6' },
                                { objectId: 'DWgmL', cssClass: 'col-md-6' },
                                { objectId: 'vmqXZS', cssClass: 'col-md-6' }
                            ]
                        },
                        {
                            category: 'Data Quality',
                            widgets: [
                                { objectId: 'pmEtfva', tableId: 'ZyGRrnd', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        }
                    ],
                    nonEducation: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'LtgN', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'pLZta', tableId: 'BvVmA', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'gaEch', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'PMgNP', tableId: 'TafmdRZ', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'rXEgxn', cssClass: 'col-md-6' },
                                { objectId: 'DWgmL', cssClass: 'col-md-6' },
                                { objectId: 'vmqXZS', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Data Quality',
                            widgets: [
                                { objectId: 'pmEtfva', tableId: 'ZyGRrnd', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        }
                    ]
                }
            },
            inventory: {
                kpis: {
                    app: 'inventory',
                    education: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'RkYJW', cssClass: 'col-md-12 qlik-widget-xs' },
                                { objectId: 'UKMZnqP', tableId: 'mGAeC', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'HxzFUA', tableId: 'xBWHHmN', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'KrTWh', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'pDxJH', cssClass: 'col-md-6 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'ggjWnE', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'mHx', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'KcUPp', tableId: 'UHBF', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'gmZmEt', tableId: 'UhFHjU', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'SpGtJgQ', tableId: 'xjBCwb', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'GsYTQh', tableId: 'HPuJYjm', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'vWt', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'hetnKE', cssClass: 'col-md-6 qlik-widget-xs' }
                            ]
                        }
                    ],
                    nonEducation: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'RkYJW', cssClass: 'col-md-12 qlik-widget-xs' },
                                { objectId: 'UKMZnqP', tableId: 'mGAeC', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'KrTWh', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'pDxJH', cssClass: 'col-md-6 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'ggjWnE', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'mHx', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'KcUPp', tableId: 'UHBF', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'SpGtJgQ', tableId: 'xjBCwb', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'vWt', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'hetnKE', cssClass: 'col-md-6 qlik-widget-xs' }
                            ]
                        }
                    ]
                }
            },
            technology: {
                kpis: {
                    app: 'technology',
                    education: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'jQupxy', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'PxGNyP', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'XbJhj', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'evNSemf', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'XxLfCUu', cssClass: 'col-md-12 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'CsdjTfU', tableId: 'fxYPf', cssClass: 'col-md-6' },
                                { objectId: 'nAp', tableId: 'wtjPa', cssClass: 'col-md-6' },
                                { objectId: 'YaupQBW', tableId: 'sJeX', cssClass: 'col-md-6' },
                                { objectId: 'mrAgdQy', tableId: 'bHet', cssClass: 'col-md-6' },
                                { objectId: 'gYDDPz', tableId: 'uVwepuw', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'KpQsZEv', tableId: 'Rxs', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'TePFVj', tableId: 'CTrWEy', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'jgjbV', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'jgaSw', cssClass: 'col-md-12 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Data Quality',
                            widgets: [
                                { objectId: 'upZLLt', cssClass: 'col-md-12' }
                            ]
                        }
                    ],
                    nonEducation: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'jQupxy', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'PxGNyP', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'XbJhj', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'evNSemf', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'XxLfCUu', cssClass: 'col-md-12 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'CsdjTfU', tableId: 'fxYPf', cssClass: 'col-md-6' },
                                { objectId: 'YaupQBW', tableId: 'sJeX', cssClass: 'col-md-6' },
                                { objectId: 'gYDDPz', tableId: 'uVwepuw', cssClass: 'col-md-6' },
                                { objectId: 'KpQsZEv', tableId: 'Rxs', cssClass: 'col-md-6' },
                                { objectId: 'mrAgdQy', tableId: 'bHet', cssClass: 'col-md-6' },
                                { objectId: 'TePFVj', tableId: 'CTrWEy', cssClass: 'col-md-6' },
                                { objectId: 'jgjbV', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'jgaSw', cssClass: 'col-md-12 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Data Quality',
                            widgets: [
                                { objectId: 'upZLLt', cssClass: 'col-md-12' }
                            ]
                        }
                    ]
                }
            },
            trips: {
                kpis: {
                    app: 'trips',
                    education: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'EPSLkj', cssClass: 'col-md-6 qlik-widget-sm' },
                                { objectId: 'gRmuz', cssClass: 'col-md-6 qlik-widget-sm' },
                                { objectId: 'nfVbSK', cssClass: 'col-md-12 qlik-widget-md' }
                            ]
                        },
                        {
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'QPgZLf', tableId: 'VTykhLR', cssClass: 'col-md-12 qlik-widget-lg' },
                                { objectId: 'RwQJL', tableId: 'dQBDtBL', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'jeTvuuG', tableId: 'pTHWCW', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'ghyeqB', tableId: 'PzMdU', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'LURYJmU', cssClass: 'col-md-12' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'XjZWdB', cssClass: 'col-md-12 qlik-widget-xs' },
                                { objectId: 'PqbaVa', tableId: 'uPbKwa', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'FANJHs', tableId: 'hWcstF', cssClass: 'col-md-12 qlik-widget-lg' },
                                { objectId: 'MhxWhf', tableId: 'HumdJP', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        }
                    ]
                }
            },
            capitalForecast: {
                kpis: {
                    app: 'capitalForecast',
                    education: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'VxjPU', cssClass: 'col-md-12 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'erUhqq', tableId: 'wzQNj', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'mHAWJ', tableId: 'YYAs', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'PNUJP', cssClass: 'col-md-12' },
                                { objectId: 'jLCQdVY', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'pBMYsEN', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'WbRqCs', tableId: 'PAKaDX', cssClass: 'col-md-12 qlik-widget-lg' },
                                { objectId: 'Xvnmd', tableId: 'FekQbV', cssClass: 'col-md-12 qlik-widget-lg' },
                                { objectId: 'akFyWt', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'utgwX', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'ehARjy', cssClass: 'col-md-12' },
                                { objectId: 'CAmXPJx', cssClass: 'col-md-12' }
                            ]
                        }
                    ],
                    nonEducation: [
                        {
                            category: 'Volume',
                            widgets: [
                                { objectId: 'VxjPU', cssClass: 'col-md-12 qlik-widget-xs' }
                            ]
                        },
                        {
                            category: 'Efficiency',
                            widgets: [
                                { objectId: 'erUhqq', tableId: 'wzQNj', cssClass: 'col-md-12 qlik-widget-sm' },
                                { objectId: 'mHAWJ', tableId: 'YYAs', cssClass: 'col-md-12 qlik-widget-sm' }
                            ]
                        },
                        {
                            category: 'Cost',
                            widgets: [
                                { objectId: 'PNUJP', cssClass: 'col-md-12' },
                                { objectId: 'jLCQdVY', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'pBMYsEN', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'WbRqCs', tableId: 'PAKaDX', cssClass: 'col-md-12 qlik-widget-lg' },
                                { objectId: 'akFyWt', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'utgwX', cssClass: 'col-md-6 qlik-widget-xs' },
                                { objectId: 'ehARjy', cssClass: 'col-md-12' }
                            ]
                        }
                    ]
                }
            }
        }
    });

'use strict';

angular.module('qlikTicket', ['dudeApi']);

'use strict';

angular.module('qlikTicket')
    .service('QlikTicketService', function ($rootScope, $window, $q, DudeApi, dudeApiConfig, userContext) {
        function getQlikTicket() {
            var NOM_NOM = 'cookie-monster-beacon';

            var img = angular.element('#' + NOM_NOM);

            if (!userContext.account || !userContext.account.market || !userContext.account.market.name) {
                return false;
            }

            $window.localStorage.setItem('dsi.market', userContext.account.market.name.toLowerCase());
            if (!img.length) {
                img = angular.element('<img />');
                img.attr('id', NOM_NOM);
                angular.element('body').append(img);
                img.css('height', '0');
                img.css('width', '0');
            }

            return '';
        }

        return {
            getQlikTicket: getQlikTicket
        };
    });

'use strict';

/**
 * @description A Layout service that is specific to organizing Qlik App Sheet 'cell' data into
 * a structure which can be digested by angularjs templating concerns. This allows us to use
 * the Qlik App Sheet itself for direction on how to layout a specific series of visualizations
 * instead of relying on statically coded JSON structures, like we do for KPIs/Trends/Etc..
 *
 * It is important to note that this service could be used for KPI/Trends as well, should their
 * native layouts in Qlik Hub ever get cleaned up and well organized.
 */
angular.module('qlikLayout', []);

'use strict';

angular.module('qlikLayout')
    .service('qlikLayoutService', function () {
        /**
         * @private
         * @description provides sorting of a collection based on member property
         * @param {string} property - object property to base the sort on
         * @returns {Function} - function to pass to sort()
         */
        var dynamicSort = function (firstOrder, secondOrder) {
            return function (a, b) {
                if (a[firstOrder] === b[firstOrder]) {
                    return (a[secondOrder] - b[secondOrder]);
                }
                if (a[firstOrder] > b[firstOrder]) {
                    return 1;
                }
                if (a[secondOrder] < b[secondOrder]) {
                    return -1;
                }

                return a[firstOrder] - b[firstOrder];
            };
        };

        /**
         * @private
         * @description Divides one integer by another to receive a decimal value
         * @param {integer} dividend - number to be divided
         * @param {integer} divisor - number to divide by
         * @returns {number}
         */
        var determineDecimal = function (dividend, divisor) {
            return dividend / divisor;
        };

        /**
         * @description ESlint * and + rule avoidance
         * @param {integer} target - number to append the percentage symbol to
         * @returns {string}
         */
        var appendPercentageSymbol = function (target) {
            return target + '%';
        };

        /**
         * @description Generates the object which a given template will use to draw the visualization
         * grid
         * @param {integer} rows - row count from the Qlik App Sheet Layout
         * @param {integer} cols - column data from the Qlik App Sheet Layout
         * @param {object|array} cellData - raw cell data from a Qlik App Sheet layout
         * @param {integer} useOffset - in some situations there may be an unaccounted for row if occupied by the filterpane which is handled separately
         * @returns {object} organized object which a template can consume to draw the visualization grid
         */
        var generateDisplayObject = function (rows, cols, cellData, useOffset) {
            var orderedCells = cellData.sort(dynamicSort('row', 'col'));
            orderedCells.forEach(function (visualization) {
                // we prefer percentages for some of these properties for display reasons
                visualization.style = {
                    position: 'absolute',
                    width: appendPercentageSymbol(determineDecimal(visualization.colspan, cols) * 100),
                    left: appendPercentageSymbol(determineDecimal(visualization.col, cols) * 100),
                    top: appendPercentageSymbol(determineDecimal(visualization.row - useOffset, rows) * 100)
                };
                // height will be a multiplier used for scaling purposes and should not be included with
                // the class specification
                visualization.height = determineDecimal(visualization.rowspan, rows);
            });
            return orderedCells;
        };

        return {
            generateDisplayObject: generateDisplayObject
        };
    });

'use strict';

angular.module('qlikInit', ['qlikApp', 'helpers']);

'use strict';

angular.module('qlikInit')
    .directive('qlikInit', function ($rootScope, $window, qlikAppService, commonMappings, qlikVisualizations) {
        return {
            restrict: 'E',
            template: '<qlik-app ng-if="$root.qlikApp"></qlik-app>',
            scope: {},
            controllerAs: 'qlikInit',
            controller: function () {
                var self = this;

                self.$onInit = function () {
                    // create visualization context
                    self.windowContext = qlikAppService.getIframeContextDetails($window);

                    self.applicationName = self.windowContext.appName || qlikAppService.getAppNameForVerticalContext(self.windowContext.vertical, self.windowContext.appType);
                    self.windowContext.appName = self.applicationName;

                    // fetch the app itself
                    qlikAppService.getQlikAppByName(self.applicationName)
                        .then(function (result) {
                            qlikAppService.emitDataToParentWindow(commonMappings.Events.QLIK_APP_LOADED, result);
                            $rootScope.$emit(commonMappings.Events.QLIK_APP_LOADED, result);
                            self.qlikAppId = result.id;
                            $rootScope.windowContext = self.windowContext;
                            $rootScope.qlikApp = result;
                            // conditionally add dashboard data
                            if (self.windowContext.appType === 'dashboard') {
                                $rootScope.marketGroup = qlikVisualizations.markets[self.windowContext.specificMarket].marketGroup;
                            }
                        });
                };
            }
        };
    });

'use strict';

angular.module('qlikForm', ['ui.router', 'navbar', 'dudeApi', 'qlikTicket', 'helpers']);

'use strict';

angular.module('qlikForm')
    .config(function ($stateProvider, QlikTicketServiceProvider, appConfig, permission) {
        var generateRoute = function (url, title, permissions) {
            return {
                url: url,
                templateUrl: 'app/components/qlikForm/qlikForm.html',
                controller: 'QlikFormController',
                controllerAs: 'qlikForm',
                permissions: permissions,
                settings: {
                    title: title
                },
                resolve: {
                    qlikTicket: function () {
                        return QlikTicketServiceProvider.$get().getQlikTicket();
                    }
                }
            };
        };

        $stateProvider
            .state('secure.maintenance', {
                url: 'maintenance',
                template: '<ui-view/>'
            })
            .state('secure.none', generateRoute('/none', 'navBar.none', [permission.navbar.kpiRead]))
            .state('secure.maintenance.kpissense', generateRoute('/kpissense', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.maintenance.forecastsense', generateRoute('/forecastsense', 'navBar.forecast', [permission.navbar.maintenance.trendsRead]))
            .state('secure.maintenance.trendsFormsense', generateRoute('/trendssense', 'navBar.trends', [permission.navbar.maintenance.trendsRead]))
            .state('secure.maintenance.mapsFormsense', generateRoute('/mapssense', '', [permission.navbar.maintenance.mapsRead]))
            .state('secure.inventoryFormsense', generateRoute('inventory/kpissense', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.events', {
                url: 'events',
                template: '<ui-view/>'
            })
            .state('secure.events.kpissense', generateRoute('/kpissense', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.events.trendsFormsense', generateRoute('/trendssense', 'navBar.trends', [permission.navbar.events.trendsRead]))
            .state('secure.events.mapsFormsense', generateRoute('/mapssense', '', [permission.navbar.events.mapsRead]))
            .state('secure.technologyFormsense', generateRoute('technology/kpissense', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.utilitiesFormsense', generateRoute('utilities/kpissense', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.capitalForecastFormsense', generateRoute('capitalForecast/kpissense', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.tripFormsense', generateRoute('trips/kpissense', 'navBar.kpis', [permission.navbar.kpiRead]));
    });

'use strict';

angular.module('qlikForm')
    .controller('QlikFormController', function ($state, $translate) {
        var self = this;
        self.title = $translate.instant($state.current.settings.title);
    });

'use strict';

angular.module('qlikExporter', ['dudeApi', 'qlikTicket']);

'use strict';

angular.module('qlikExporter')
    .factory('qlikExporterService', function ($rootScope, $window, commonMappings) {
        var exportHandler = null;
        var getExportUrls = function (appName, widgets, callback) {
            if (!exportHandler) {
                exportHandler = $rootScope.$on(commonMappings.Events.QLIK_APP_EXPORT_SHEET_WIDGETS_RESPONSE, function (event, args) {
                    callback(args);
                });
            }
            $window.angular.element('#qlik-frame')[0]
                .contentWindow.angular.element('body').scope()
                .$emit(commonMappings.Events.QLIK_APP_EXPORT_SHEET_WIDGETS_REQUEST, { appName: appName, widgets: widgets });
        };

        var getList = function (appName, sheet, callback) {
            var handler = $rootScope.$on(commonMappings.Events.QLIK_APP_FETCH_SHEET_WIDGETS_RESPONSE, function (event, args) {
                callback(args);
                handler();
            });
            $window.angular.element('#qlik-frame')[0]
                .contentWindow.angular.element('body').scope()
                .$emit(commonMappings.Events.QLIK_APP_FETCH_SHEET_WIDGETS_REQUEST, { appName: appName, sheet: sheet });
        };

        return {
            getList: getList,
            getExportUrls: getExportUrls
        };
    });

/**
 * @ngdoc directive
 * @name qlikExporter.qlikExporter
 * @restrict E
 * @description
 *
 * Displays the button for opening panel to export apps
 *
 * @param {string} app the name of the dashboard
 * @param {object} sheet object containing name and id for the current sheet
 *
 */

'use strict';

angular.module('qlikExporter')
    .component('qlikExporter', {
        bindings: {
            app: '<',
            sheet: '<'
        },
        templateUrl: 'app/components/qlikExporter/qlikExporter.html',
        controller: 'QlikExporterController',
        controllerAs: 'qlikExporter'
    })
    .controller('QlikExporterController', function (
        $timeout,
        $scope,
        $window,
        $translate,
        $q,
        qlikExporterService,
        appConfig,
        userContext
    ) {
        var self = this;
        self.exportPanelOpen = false;
        self.selectAll = false;
        self.titles = {
            title: ''
        };
        self.widgets = [];

        /**
         * @ngdoc method
         * @name openExportPanel
         * @methodOf qlikExporter.qlikExporter
         * @description A method used to initialize the sliding panel for display
         */
        self.openExportPanel = function () {
            qlikExporterService.getList(self.app, self.sheet.id, self.openExportPanelCallback);
        };

        /**
         * @ngdoc method
         * @name openExportPanelCallback
         * @methodOf qlikExporter.qlikExporter
         * @description A method used to open the sliding panel and populate the widgets property it is bound to
         *
         * @param {object} widgets List of widget objects
         */
        self.openExportPanelCallback = function (widgets) {
            self.widgets = widgets;
            self.exportPanelOpen = true;
            $scope.$digest();
        };

        /**
         * @ngdoc method
         * @name export
         * @methodOf qlikExporter.qlikExporter
         * @description A method used to begin the export process.  It sends the selected widgets to the service for export.
         */
        self.export = function () {
            var selectedWidgets = self.widgets.filter(function (widget) {
                return widget.selected;
            }).map(function (widget) {
                return widget.id;
            });

            qlikExporterService.getExportUrls(self.app, selectedWidgets, self.exportCallback);
        };

        /**
         * @ngdoc method
         * @name exportCallback
         * @methodOf qlikExporter.qlikExporter
         * @description A method used to download widget data files
         * @param {array} widgets List of widget objects to download
         */
        self.exportCallback = function (widgets) {
            var userId = userContext.user.id;
            var userDirectory = 'DUDEPLATFORM';
            widgets.reduce(function (promise, widget, currentIndex) {
                return promise.then(function () {
                    return $q(function (resolve) {
                        $timeout(function () {
                            var now = new Date();
                            var timestamp = [now.getFullYear(), now.getMonth() + 1, now.getDate()].join('-');
                            var fileName = widget.title + '.' + timestamp;
                            var fileUri = 'https://' + appConfig.settings.qlikServerUri + widget.url;
                            var proxy = appConfig.api.qlikthenticator
                                + '/export?url='
                                + encodeURIComponent(fileUri)
                                + '&name=' + encodeURIComponent(fileName)
                                + '&userId=' + encodeURIComponent(userId)
                                + '&userDirectory=' + encodeURIComponent(userDirectory);

                            var lastOne = currentIndex + 1 === widgets.length;
                            resolve(self.downloadURI(proxy, fileName, lastOne));
                        }, 500);
                    });
                });
            }, $q.resolve());
        };

        /**
         * @ngdoc method
         * @name downloadURI
         * @methodOf qlikExporter.qlikExporter
         * @description A method used to initiate a file download.  To prevent the jarring experience of opening new windows,
         * this method initiates downloads without visual ticks.
         *
         * @param {string} uri File uri to download
         */
        self.downloadURI = function (uri, fileName, lastOne) {
            $timeout(function () {
                var link = $window.angular.element('<a></a>')[0];
                link.download = fileName + '.xlsx';
                link.href = uri;
                $window.angular.element('body').append(link);
                link.click();
            }, 0)
                .then(function () {
                    if (lastOne) {
                        $window.parent.angular.element('dude-navigation').scope().$emit('dudeLog:XLSXportSuccess');
                    }
                })
                .catch(function () {
                    $window.parent.angular.element('dude-navigation').scope().$emit('dudelog:XLSXportFailure');
                });
        };

        /**
         * @ngdoc method
         * @name onSelectAllChange
         * @methodOf qlikExporter.qlikExporter
         * @description A method used to handle the event when a user changes the "Select All" state from the sliding panel
         */
        self.onSelectAllChange = function () {
            self.widgets.forEach(function (widget) {
                widget.selected = self.selectAll;
            });
        };

        /**
         * @ngdoc object
         * @name functions
         * @methodOf qlikExporter.qlikExporter
         * @description An object that contains meta data and behaviours for the sliding panel buttons
         * @returns {object} meta data for the sliding panel buttons
         */
        self.functions = {
            saveFunction: function () {
                self.export();
                self.selectAll = false;
                return $q.resolve();
            },
            saveButtonText: $translate.instant('exporter.export')
        };

        /**
         * @ngdoc object
         * @name $onInit
         * @methodOf qlikExporter.qlikExporter
         */
        self.$onInit = function () {
            $scope.$watch('qlikExporter.sheet', function (newVal) {
                self.titles = {
                    title: newVal.name
                };
            });
            $scope.$watch('qlikExporter.widgets', function (newVal) {
                self.selectAll = !!newVal.length && newVal.every(function (widget) {
                    return widget.selected;
                });
            }, true);
        };
    });

'use strict';

angular.module('qlikAccountNotFound', [
    'ui.router',
    'translateDudeControls'
]);

'use strict';

angular.module('qlikAccountNotFound')
    .run(function ($rootScope, $state) {
        $rootScope.$on('qlikError:accountNotFound', function () {
            $state.go('secure.accountNotFound');
        });
    });

'use strict';

angular.module('qlikAccountNotFound')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.accountNotFound', {
                url: 'accountnotfound',
                templateUrl: 'app/components/qlikAccountNotFound/qlikAccountNotFound.html',
                controller: 'qlikAccountNotFoundController',
                controllerAs: 'qlikAccountNotFound'
            });
    });

'use strict';

angular.module('qlikAccountNotFound')
    .controller('qlikAccountNotFoundController', function ($stateParams, authService) {
        var self = this;
        self.refId = $stateParams.refId;

        authService.getContext().then(function (userContext) {
            self.profile = userContext;
        });
    });

'use strict';

angular.module('qlikDashboard', ['ui.router', 'navbar', 'dudeApi', 'qlikTicket', 'helpers']);

'use strict';

angular.module('qlikDashboard')
    .config(function ($stateProvider, QlikTicketServiceProvider, permission) {
        var generateRoute = function (url, title, permissions) {
            return {
                url: url,
                templateUrl: 'app/components/qlikDashboard/qlikDashboard.html',
                permissions: [permissions],
                controller: 'QlikDashboardController',
                controllerAs: 'qlikDashboard',
                settings: {
                    title: title
                },
                resolve: {
                    qlikTicket: function () {
                        return QlikTicketServiceProvider.$get().getQlikTicket();
                    },
                    qlikTicketService: function () {
                        return QlikTicketServiceProvider;
                    }
                }
            };
        };

        $stateProvider
            .state('secure.maintenance.dashboardForm', generateRoute('/dashboard', 'navBar.dashboard', permission.navbar.maintenance.dashboardRead))
            .state('secure.events.dashboardForm', generateRoute('/dashboard', 'navBar.dashboard', permission.navbar.events.dashboardRead))
            .state('secure.maintenance.forecast', generateRoute('/forecast', 'navBar.forecast', [permission.navbar.maintenance.trendsRead]))
            .state('secure.events.kpis', generateRoute('/kpis', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.events.trendsForm', generateRoute('/trends', 'navBar.trends', [permission.navbar.events.trendsRead]))
            .state('secure.events.mapsForm', generateRoute('/maps', '', [permission.navbar.events.mapsRead]))
            .state('secure.technologyForm', generateRoute('technology/kpis', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.utilitiesForm', generateRoute('utilities/kpis', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.capitalForecastForm', generateRoute('capitalForecast/kpis', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.tripForm', generateRoute('trips/kpis', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.maintenance.kpis', generateRoute('/kpis', 'navBar.kpis', [permission.navbar.kpiRead]))
            .state('secure.maintenance.trendsForm', generateRoute('/trends', 'navBar.trends', [permission.navbar.maintenance.trendsRead]))
            .state('secure.maintenance.mapsForm', generateRoute('/maps', '', [permission.navbar.maintenance.mapsRead]))
            .state('secure.inventoryForm', generateRoute('inventory/kpis', 'navBar.kpis', [permission.navbar.kpiRead]));
    });

'use strict';

angular.module('qlikDashboard')
    .controller('QlikDashboardController', function (
        appConfig,
        commonMappings,
        localStorageHelpers,
        $location,
        qlikTicket,
        qlikTicketService,
        qlikVisualizationsService,
        $sce,
        $state,
        $rootScope,
        $translate,
        utility,
        $window, $q) {
        var self = this;
        self.height = commonMappings.Display.qlikFrame.height;
        self.width = commonMappings.Display.qlikFrame.width;
        var market = localStorageHelpers.getMarket($window);

        var getCookieValue = function (cookieName) {
            var cookies = document.cookie;
            var cookieArray = cookies.split(';');

            for (var i = 0; i < cookieArray.length; i++) {
                var cookie = cookieArray[i].trim();
                if (cookie.indexOf(cookieName + '=') === 0) {
                // Found the cookie with the specified name
                    return cookie.substring(cookieName.length + 1);
                }
            }

            // Cookie not found
            return null;
        };
    // REGION: Internal
        /**
         * @private
         * @type Inter-Iframe Communication
         * @description communicates data down into the child iframe and then $emits through that angular app
         * via the QlikInit component's scope
         * @param data
         */
        var messageToQlikAngular = function (data) {
            if (data.url) {
                var sessionID = getCookieValue('sessionID');
                self.appName = data.url + sessionID;
                self.appType = 'dashboard';
            } else {
                var qlikAngularjs = angular.element('#qlik-frame')[0].contentWindow.angular;
                if (qlikAngularjs) {
                    qlikAngularjs.element('qlik-init').scope().$emit(commonMappings.Events.QLIK_APP_SWITCH_SHEET, data);
                }
            }
        };

        /**
         * @private
         * @type Internal Helper
         * @description Assigns the new desired active sheet and calls broadcastToQlikInit
         * @param sheet - the sheet to set as active
         */
        var setActiveSheet = function (sheet) {
            self.selectedSheet = sheet;
            messageToQlikAngular(sheet);
        };
    // END REGION

    // REGION: Template Actions
        /**
         * @type UI Action
         * @description handles interaction with the "sheets dropdown"
         * @param sheet - the sheet value selected by a user from the UI(template)
         * @todo - consider creating a component for this UI and related logic
         */
        self.switchSheet = function (sheet) {
            setActiveSheet(sheet);
        };
    // END REGION
        var getLocalStorageValue = function (key, callback, maxAttempts, delay) {
            maxAttempts = typeof maxAttempts !== 'undefined' ? maxAttempts : 5;
            delay = typeof delay !== 'undefined' ? delay : 5000;
            var deferred = $q.defer(); // AngularJS deferred object
            var attempts = 0;

            function tryGet() {
                var value = localStorage.getItem(key);
                if (value !== null) {
                    try {
                        var result = callback(value);
                        deferred.resolve(result);
                    } catch (err) {
                        deferred.reject(err);
                    }
                } else {
                    attempts++;
                    if (attempts < maxAttempts) {
                        setTimeout(tryGet, delay);
                    } else {
                        deferred.resolve(null); // or reject, based on your app logic
                    }
                }
            }

            tryGet();

            return {
                $promise: deferred.promise
            };
        };
    // REGION: General Init
        self.title = $translate.instant($state.current.settings.title);
        self.visualization = qlikVisualizationsService.getVisualizations($location.path(), market);
        self.qlikVisualizationAppRoute = qlikVisualizationsService.getVisualizationsAtRoute($location.path());
        if (self.visualization) {
            getLocalStorageValue('qlikCloudApps', JSON.parse).$promise.then(function (appQlik) {
                var appName = '';
                var visualization = self.visualization;

                if (Object.prototype.toString.call(self.visualization) === '[object Array]') {
                    visualization = self.visualization[0];
                }
                appQlik.forEach(function (item) {
                    if (self.qlikVisualizationAppRoute.app != null) {
                        if (self.qlikVisualizationAppRoute.app.toLowerCase() === 'forecast' || self.qlikVisualizationAppRoute.app.toLowerCase() === 'maps' || self.qlikVisualizationAppRoute.app.toLowerCase() === 'maintenance' || self.qlikVisualizationAppRoute.app.toLowerCase() === 'trends'
                                || self.qlikVisualizationAppRoute.app.toLowerCase() === 'inventory' || self.qlikVisualizationAppRoute.app.toLowerCase() === 'events' || self.qlikVisualizationAppRoute.app.toLowerCase() === 'technology'
                                || self.qlikVisualizationAppRoute.app.toLowerCase() === 'energy' || self.qlikVisualizationAppRoute.app.toLowerCase() === 'trips' || self.qlikVisualizationAppRoute.app.toLowerCase() === 'capitalforecast') {
                            if (item.name.toLowerCase() === appConfig.qlikApplications[self.qlikVisualizationAppRoute.app].toLowerCase()) {
                                appName = item.resourceId;
                            }
                        }
                    } else if (item.name.toLowerCase() === appConfig.qlikDashboardApplications[visualization.app].toLowerCase()) {
                        appName = item.resourceId;
                    }
                });
                if (visualization.app === 'events') {
                    self.appName = appName;
                    self.appType = 'dashboard';
                } else {
                        // var sessionID = getCookieValue('sessionID');
                    self.appName = appName;
                        // + sessionID;
                    self.appType = 'dashboard';
                }

                    // setActiveSheet(self.visualization.sheets[0] + sessionID);
            });
        }
    // END REGION
    });

'use strict';

angular.module('qlikApp')
    .constant('qlikAppConfig', {
        timeouts: {
            collection: 1500, // dashboards or views with multiple "widgets"
            individual: 150 // isolated / fullscreen presentation
        }
    });

'use strict';

angular.module('qlikApp')
    .service('qlikAppService', function ($window, $rootScope, $q, appConfig, localStorageHelpers, qlikNativeObj, commonMappings, qlikVisualizations) {
        var qlikApps;

        var exportQueue = {
            expected: 0,
            set: []
        };

        // qlik require.js request options
        var config = {
            prefix: '/platform/',
            host: 'bi-master.dudesoln.com',
            port: 443,
            isSecure: true
        };

        // Qlik App Object qType(s)
        var GenericObjects = commonMappings.GenericObjects;

        /**
         * @description Fetches all apps from the Qlik Sense App Repository
         * @returns {Promise[object]} - promise result contains a collection of known qlikapps
         */
        var getQlikApps = function () {
            return (qlikApps) ?
                $q(function (resolve) {
                    resolve(qlikApps);
                }) :
                $q(function (resolve) {
                    qlikNativeObj.getGlobal(config)
                        .getAppList(function (result) {
                            qlikApps = result;
                            resolve(qlikApps);
                        });
                });
        };

        /**
         * @description Gets a specific appid by name of the app
         * @param {string} name - name of the app to fetch
         * @returns {Promise} - promise result contains the fetch result of the desired app
         */
        var getQlikAppIdByName = function (name) {
            return getQlikApps().then(function (apps) {
                var result = apps.filter(function (app) {
                    return app.qDocName === name;
                });

                return (result[0]) ? result[0].qDocId : '';
            });
        };

        /**
         * @description fetches a specific qlik app by name
         * @param {string} name - name of the app to fetch
         * @returns {Promise} - promise result contains the fetched app desired
         */
        var getQlikAppByName = function (name) {
            return getQlikAppIdByName(name).then(function (id) {
                return qlikNativeObj.openApp(id, config);
            });
        };

        /**
         * @description fetches qlik app by ID
         * @param {integer} id - id of the qlik app to fetch
         * @returns {Promise} - promise result contains the app requested
         */
        var getQlikAppById = function (id) {
            return $q(function (resolve) {
                resolve(qlikNativeObj.openApp(id, config));
            });
        };

        /**
         * @description Fetches Qlik ID and Title for all widgets of a given sheet
         * @param sheet
         * @returns {Promise} - promise result containing a map of widget id and title for each widget of the sheet
         */
        var getWidgetIdAndTitleForAppSheet = function (sheet) {
            return $rootScope.qlikApp.getObject(sheet)
                .then(function (sheetContext) {
                    return sheetContext.getChildInfos();
                })
                .then(function (sheetChildren) {
                    var filteredChildren = sheetChildren.filter(function (child) {
                        return GenericObjects.whiteList.indexOf(child.qType) !== -1;
                    });

                    return filteredChildren.map(function (child) {
                        return $rootScope.qlikApp.getObject(child.qId);
                    });
                })
                .then(function (childrenObjects) {
                    return $q.all(childrenObjects).then(function (children) {
                        return children.map(function (child) {
                            return child.getProperties();
                        });
                    });
                })
                .then(function (childrenProps) {
                    return $q.all(childrenProps)
                        .then(function (childProperties) {
                            return childProperties.map(function (child) {
                                return {
                                    id: child.qInfo.qId,
                                    title: child.title
                                };
                            });
                        });
                })
                .catch(function (err) {
                    return err;
                });
        };

        // END REGION

        // REGION : Qlik App Related
        /**
         * @private
         * @description Provides a flexible way to sort through a collection of Qlik App Widgets by a designated property
         * @param {array<object>>} widgets - widget collection to search through
         * @param {array<string>} toMatch - collection of properties of object to select by, inclusive
         * @param {string} property - property of the Qlik App Widget to examine
         * @returns {array<object>} collection of matched objects
         */
        var getWidgetTypeByProperty = function (widgets, toMatch, property) {
            return widgets.filter(function (widget) {
                return toMatch.indexOf(widget[property]) > -1;
            });
        };

        /**
         * @description Provides an intermediary model which contains information about the layout and general presentation
         * information of a given Qlik App Sheet
         * @param {object} sheet - Qlik App Sheet to delve for layout data
         * @returns {object} Intermediary model representing various presentation information of the given Qlik App Sheet
         */
        var getSheetLayout = function (sheet) {
            return sheet.getLayout()
                .then(function (sheetLayoutData) {
                    return {
                        rows: sheetLayoutData.rows,
                        columns: sheetLayoutData.columns,
                        filterBar: getWidgetTypeByProperty(sheetLayoutData.cells, ['filterpane'], 'type'),
                        graphics: getWidgetTypeByProperty(sheetLayoutData.cells, commonMappings.GenericObjects.whiteList, 'type')
                    };
                });
        };

        /**
         * @type QlikApp Helper
         * @description Gets all sheets for a given qlik app
         * @param {object} app Qlik App
         * @param {string} category - type of app : maintenance / events / etc..
         * @param {sring} appType - 'dashboard' expected. needed for a helper
         * @param {string} market - general market associated with the application
         * @returns {array<object>} All sheets related to the given app, as Qlik Capability GenericType
         * @TODO : This can be simplified by changing this to utilize the app.getObjects(['sheet']), *tech-debt-marker*
         */
        var getAppSheets = function (app, vertical, appType, market) {
            var knownSheets = qlikVisualizations.layouts[vertical][appType][market].sheets;
            return knownSheets.map(function (sheet) {
                return app.getObject(sheet.id);
            });
        };

        /**
         * @Type Qlik Helper
         * @description gets a specific object from a Qlik App
         * @param app - qlik app to retrieve from
         * @param qId - qlik object id to retrieve
         * @returns {Promise}
         */
        var getObjectFromApp = function (app, qId) {
            return app.getObject(qId);
        };

        var getWidgetGroupsForContext = function (vertical, appType, market) {
            return qlikVisualizations.layouts[vertical][appType][market];
        };
        // END REGION

        // REGION : User/Account Context Related
        /**
         * @type User/Account Context Helper
         * @description Many specialized market attributions found in classic/dude platform are not uniquely
         * relevant in DI. This function is meant determine the general market which they belong to.
         * @param {string} market - specialized market for given context
         * @returns {string} market category
         */
        var determineMarketCategory = function (market) {
            return Object.keys(commonMappings.markets)
                .filter(function (category) {
                    // eslint-disable-next-line no-prototype-builtins
                    return commonMappings.markets[category].hasOwnProperty(market.toUpperCase());
                })
                .pop();
        };
        // END REGION

        // REGION : Window/Iframe Scrape Related

        /**
         * @private
         * @type Window/Iframe Context Scraper
         * @description parses iframe URL for app identifier, expects winder.location.href to resemble: // "http://<domain:port>/qlik-iframe.html?app=<APP_NAME>"
         * @param {object} winder - $window object
         * @returns {string}
         */
        var parseAppNameFromIframeWindow = function (winder) {
            var initialStep = winder.location.href.split('?');
            if (initialStep.length < 2) {
                return null;
            }
            var lastStep = initialStep[1].split('=');
            if (lastStep.length < 2) {
                return null;
            }
            return lastStep[1];
        };

        /**
         * @description When 'app=null' in the query string, that designates a non-dashboard app, this takes the available context and fetches the name from our static list
         * @param {string} vertical - vertical of application
         * @returns {string} app name
         */
        function getAppNameForVerticalContext(vertical, appType) {
            if (appType === 'maps') {
                vertical = 'maps';
            }
            if (appType === 'forecast') {
                vertical = 'forecast';
            }
            return appConfig.qlikApplications[vertical];
        }

        /**
         * @description Detects whether a given string is a valid UUID
         * @param {string} val - the value to test
         * @returns {boolean} returns true if a valid UUID, otherwise false
         */
        var isUUID = function (val) {
            var isGuidRegex = /^([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})|[0-9]+$/i;

            if (val.match(isGuidRegex)) {
                return true;
            }
            return false;
        };

        /**
         * @type Window/Iframe Context Scraper
         * @description Parses a portion of necessary context information from the qlik-frame
         * @param {object} window - $window object
         * @returns {object} describes window
         */
        var getIframeContextDetails = function (winder) {
            var windowLocHref = winder.parent.window.location.href;
            var specificMarket = localStorageHelpers.getMarket(winder);
            var parentLocation = windowLocHref.split('/');
            var appType = parentLocation.pop();

            if (appType) {
                if (isUUID(appType)) {
                    appType = 'CV';
                }
            }

            var appName = parseAppNameFromIframeWindow(winder);
            var vertical = parentLocation.pop();
            return {
                appType: appType,
                appName: appName,
                vertical: vertical,
                market: determineMarketCategory(specificMarket),
                specificMarket: specificMarket
            };
        };

        /**
         * @type Event
         * @description Emits event up into the parent of the qlik-frame
         * @event {string} event - name of the event to $emit
         * @param {object} data - whatever to pass to the parent window
         */
        var emitDataToParentWindow = function (event, data) {
            $window.parent.angular.element('.ng-scope').first().scope().$emit(event, data);
        };

        /**
         * @type Event
         * @description Broadcasts event down the parent of the qlik-frame's scope
         * @event {string} event - name of the event to $broadcast
         * @param {object} data - whatever to pass to the parent window
         */
        var broadcastDataToParentWindow = function (event, data) {
            $window.parent.angular.element('.ng-scope').first().scope().$broadcast(event, data);
        };
        // END REGION

        // REGION: ExportRelated

        var _pollExportQueue = function () {
            if (exportQueue.expected === exportQueue.set.length) {
                broadcastDataToParentWindow(commonMappings.Events.QLIK_APP_EXPORT_SHEET_WIDGETS_RESPONSE, exportQueue.set);
                exportQueue.set = [];
                return;
            }
            $window.setTimeout(_pollExportQueue, 500);
        };

        var exportWidgets = function (exportDetail) {
            var widgetQueue = exportDetail.widgets.map(function (widget) {
                return $rootScope.qlikApp.getObject(widget);
            });
            $q.all(widgetQueue)
                .then(function (widgets) {
                    return widgets.map(function (widget) {
                        return {
                            data: widget,
                            title: widget.getProperties().then(function (props) {
                                return props.title;
                            })
                        };
                    });
                })
                .then(function (compositeWidgets) {
                    return compositeWidgets.map(function (widget) {
                        return {
                            title: widget.title,
                            // eslint-disable-next-line new-cap
                            table: new qlikNativeObj.table(widget.data)
                        };
                    });
                })
                .then(function (tableWidgets) {
                    exportQueue.expected = tableWidgets.length;
                    _pollExportQueue();
                    tableWidgets.forEach(function (tWidg) {
                        $q.all([tWidg.table, tWidg.title])
                            .then(function (doneWidget) {
                                doneWidget[0].exportData({
                                    download: false,
                                    format: 'OOXML',
                                    filename: 'what'
                                }, function (xlsURI) {
                                    exportQueue.set.push({ title: doneWidget[1], url: xlsURI });
                                });
                            });
                    });
                })
                .catch(function (err) {
                    return err;
                });
        };

        $rootScope.$on(commonMappings.Events.QLIK_APP_FETCH_SHEET_WIDGETS_REQUEST, function (_event, data) {
            getWidgetIdAndTitleForAppSheet(data.sheet)
                .then(function (widgetList) {
                    broadcastDataToParentWindow(commonMappings.Events.QLIK_APP_FETCH_SHEET_WIDGETS_RESPONSE, widgetList);
                });
        });

        $rootScope.$on(commonMappings.Events.QLIK_APP_EXPORT_SHEET_WIDGETS_REQUEST, function (_event, data) {
            exportWidgets(data);
        });
        // END REGION

        return {
        // Qlik App Acquisition functions
            getQlikAppIdByName: getQlikAppIdByName,
            getQlikAppByName: getQlikAppByName,
            getQlikAppById: getQlikAppById,
            getQlikApps: getQlikApps,

            // Qlik App Detail functions
            getAppSheets: getAppSheets,
            getWidgetGroupsForContext: getWidgetGroupsForContext,
            getObjectFromApp: getObjectFromApp,
            getSheetLayout: getSheetLayout,

            // DI Context methods
            getIframeContextDetails: getIframeContextDetails,
            getAppNameForVerticalContext: getAppNameForVerticalContext,
            emitDataToParentWindow: emitDataToParentWindow

        };
    });

/**
 * @ngdoc directive
 * @name qlikApp.qlikApp
 * @restrict E
 * @description
 *
 * Opens a Qlik application, gets a lists of visualization displays them on the screen
 * Note: Qlik tickets are currently retrieved from localstorage.
 *
 * Usage:
 * <qlik-app></qlik-app>
 *
 */

'use strict';

angular.module('qlikApp')
    .directive('qlikApp', function ($rootScope, $timeout, $interval, $q, $document, $location, $window, qlikVisualizationsService, utility, appConfig, qlikAppConfig) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/qlikApp/qlikApp.html',
            require: '^qlikInit',
            controllerAs: 'qlikApp',
            controller: function () {
                var self = this;
                self.accountVerified = false;
                self.clearFilters = function () {
                    $rootScope.qlikApp.clearAll();
                };
            },
            link: {
                pre: function ($scope) {
                    if (!$scope.$parent.qlikInit.qlikAppId) {
                        return;
                    }
                    var IFRAME_ID = 'qlik-frame';
                    var NON_FATAL_QLIK_APP_ERRORS = [
                        6003,
                        -32602
                    ];

                    $window.config.identity = utility.getUniqueId();
                    $rootScope.isKpi = $scope.$parent.qlikInit.windowContext.appType === 'kpis';
                    $rootScope.isForecast = $scope.$parent.qlikInit.windowContext.appType === 'forecast';

                    // listen for the errors from the websocket (aka session)
                    // includes access denied and license error (jsonrpc results)
                    $rootScope.qlikApp.model.session.Error.bind(function () {
                        $rootScope.$emit('qlikFrameError', arguments[0]);
                    });

                    // Reset the height of the iframe to the height of the content
                    var resizeIframe = function () {
                        angular.element($document).height();
                        $window.parent.document.getElementById(IFRAME_ID).height = angular.element($document).height();
                    };

                    $rootScope.$on('force-resize', function () {
                        $timeout(resizeIframe, qlikAppConfig.timeouts.collection);
                    });

                    // Maps do not assume filtering by account
                    if ($scope.$parent.qlikInit.applicationName === 'maps') {
                        $timeout(resizeIframe, qlikAppConfig.timeouts.collection);
                        return;
                    }

                    var accountNumber = $window.localStorage.getItem('dsi.systemOfRecordAccountNumber');
                    var systemOfRecordAccountNumber = parseInt(accountNumber, 10);

                    // trigger outer iframe to blow up if no selection found
                    if (!systemOfRecordAccountNumber) {
                        $window.dispatchError('dudeError:500', 'Unable to select account');
                        return;
                    }

                    $rootScope.$on('qlikFrameError', function (event, errorContext) {
                        if (errorContext.error.message === 'Request aborted') {
                            return;
                        }

                        $window.dispatchError('dudeLog:qlikFrameError', JSON.stringify(errorContext));
                        if (NON_FATAL_QLIK_APP_ERRORS.indexOf(errorContext.error.code) > -1) {
                            // swallow this, its a benign qlik internal error code
                            return;
                        }
                        if (errorContext.error.message === 'Access denied') {
                            $window.dispatchError('qlikError:accountNotFound', 'No Data Found');
                        } else {
                            $window.dispatchError('dudeError:500', 'Unable to select account');
                        }
                    });

                    // still verify account exists for dashboards because we can't add our own handlers into the single
                    // page stuff from qlik, this will trip section access
                    if ($scope.$parent.qlikInit.iframeUrl) {
                        var acctNum = $rootScope.qlikApp.field('AcctNum');
                        if (typeof systemOfRecordAccountNumber === 'number') {
                            acctNum.selectValues([systemOfRecordAccountNumber], false, false);
                        }

                        var values = acctNum.getData({ rows: 1 });

                        var listener = function () {
                            values.OnData.unbind(listener);
                        };
                        values.OnData.bind(listener);
                    }
                    $timeout(resizeIframe, qlikAppConfig.timeouts.collection);
                }
            }
        };
    });

'use strict';

angular.module('navbar', ['dudeAuth', 'dudeControlsShell', 'dudeControls', 'translate', 'dudeLog', 'catalyst', 'helpers']);

'use strict';

angular.module('navbar')
    .controller('NavbarController', function ($rootScope, $state, $translate, $q, dudeApiConfig, userContext, localStorageService, authService, marketizr, market, log, roleHelpers, appConfig, navbarService, commonMappings, customVisualizationService, myFilesService, embeddedMessagingService) {
        var self = this;
        var userName = '';

        self.title = {
            text: $translate.instant('navBar.title'),
            routerPath: 'secure.interceptor',
            subText: ''
        };

        self.isRequester = roleHelpers.isRequester();
        self.isTechnician = roleHelpers.isTechnician();
        self.isManufacturing = marketizr.hasMarkets(market.mfg);
        self.isGovernment = marketizr.hasMarkets(market.gov);
        self.options = {
            highlightSelected: true
        };

      // NEW: Live Chat trigger (Embedded Messaging)
        self.openChat = function () {
            embeddedMessagingService.openChat();
        };

        self.logout = function (event) {
            event.preventDefault();
            authService.logout();
        };

        self.search = null;

        var createNavigationArray = function () {
            var products = {};
            self.products.data.forEach(function (data) {
                products[data.name] = data.name;
            });

            if (localStorageService.canHandle()) {
                localStorageService.removeItem('dsi.products');
                localStorageService.saveItem('dsi.products', products);
                localStorageService.removeItem('dsi.userId');
                localStorageService.saveItem('dsi.userId', userContext.user.id);
            }

            var permissions = {};

            self.profile.user.permissions.forEach(function (perm) {
                permissions[perm.name] = perm.name;
            });

            self.navigationArray = navbarService.getNavigationArray(self.market, products, permissions, self.hasFiles, self.custVis)
              .concat([
                  {
                      name: $translate.instant('navBar.userSettings'),
                      icon: 'fa-user',
                      hasPermission: true,
                      type: 'iconMenu',
                      accordion: [
                          {
                              name: userName,
                              type: 'text',
                              hasPermission: true
                          },
                          {
                              name: 'divider',
                              hasPermission: true
                          },
                          {
                              name: $translate.instant('navBar.logout'),
                              clickFunction: self.logout,
                              icon: 'fa-sign-out',
                              hasPermission: true
                          }
                      ]
                  }
              ]);
        };

        var navigateToDefaultPage = function () {
            var defaultPage = navbarService.getDefaultPage(self.navigationArray);
            if (!defaultPage) {
                $rootScope.$emit('dudeError:NoSubscriptions', self.profile.account.systemOfRecordAccount.sourceAbbreviation);
            } else if ($state.current.name === 'secure.home') {
                $state.go(defaultPage);
            }
        };

        $q.all({
            files: myFilesService.loadMyFiles(),
            visuals: customVisualizationService.loadVisualizations() || { total: 0 }
        }).then(function (data) {
            self.hasFiles = !!(data.files.total);
            self.custVis = data.visuals;
            self.products = userContext.accountProducts;
            self.market = userContext.account.market.name;
            self.support = {
                phoneText: $translate.instant('helpDropdown.phone.phoneDisplay'),
                phoneHref: $translate.instant('helpDropdown.phone.phoneHref'),
                emailTitle: $translate.instant('helpDropdown.email.title'),
                emailAddress: $translate.instant('helpDropdown.email.address'),
                liveChat: true,
                liveAgentAccountId: appConfig.settings.liveAgentAccountId,
                helpLink: commonMappings.onlineDocURLs[self.market] || commonMappings.onlineDocURLs.default
            };
            self.support.accountNumber = userContext.account.number;
            self.support.profile = userContext;
            self.title.subText = userContext.account.name;

            userName = userContext.user.firstName + ' ' + userContext.user.lastName;

            if (localStorageService.canHandle()) {
                if (userContext.account.systemOfRecordAccount && userContext.account.systemOfRecordAccount.accountNumber) {
                    localStorageService.saveItem('dsi.systemOfRecordAccountNumber', userContext.account.systemOfRecordAccount.accountNumber);
                } else {
                    localStorageService.removeItem('dsi.systemOfRecordAccountNumber');
                }
                localStorageService.saveItem('dsi.state', userContext.account.location.region);
            }

            self.profile = userContext;

          // INIT Embedded Messaging once
            embeddedMessagingService.init({
                productName: 'Dude Intelligence',
                orgId: appConfig.orgId,
                deploymentName: 'MIAW_Deployment',
                deploymentUrl: appConfig.deploymentUrl,
                scrt2URL: appConfig.scrt2URL
            })
              .catch(function (err) {
                  log.error('Embedded Messaging init failed', err);
              });

            createNavigationArray();
            navigateToDefaultPage();
        });
    });

/**
 * @ngdoc service
 * @name navbar.navbarService
 * @requires $translate
 * @requires helpers.commonMappings
 * @requires navbar.MenuItem
 * @requires catalystShared.appConfig
 * @requires permission
 *
 * @description
 * Service for building the navigation array for navbar
 *
 */

'use strict';
angular.module('navbar')
    .service('navbarService', function ($translate, commonMappings, MenuItem, appConfig, featuresHelper, permission, customVisualizationService) {
        // shortcut vars
        var products = commonMappings.products;
        var markets = commonMappings.markets;

        // TODO: represent maintenance and events permission updates
        var getEntireMenu = function (hasFiles, custVis) {
            var hasVis = !!(custVis.length);

            var entireMenu = [
                new MenuItem({
                    name: $translate.instant('navBar.maintenance'),
                    routerPath: 'secure.maintenance.kpis',
                    parentState: 'secure.maintenance',
                    permissions: [permission.navbar.kpiRead],
                    visibility: {
                        education: {
                            markets: markets.education,
                            products: [
                                [products.MD, products.COMMUNITY],
                                [products.PMD, products.COMMUNITY],
                                [products.MKPI],
                                [products.PMKPI]
                            ]
                        },
                        nonEducation: {
                            markets: markets.nonEducation,
                            products: [
                                [products.MEWO], [products.MEPM]
                            ]
                        }
                    },
                    icon: 'fa-wrench'
                }
                ).addChildren([
                    new MenuItem({
                        name: $translate.instant('navBar.dashboard'),
                        routerPath: 'secure.maintenance.dashboardForm',
                        permissions: [permission.navbar.maintenance.dashboardRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MKPI],
                                    [products.PMKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    new MenuItem({
                        name: $translate.instant('navBar.execSummary'),
                        routerPath: 'secure.maintenance.execSummaryForm',
                        permissions: [permission.navbar.maintenance.executiveSummaryRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MKPI],
                                    [products.PMKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    // Maintenance dashboard read permission because KPI access is granted on the parent menuitem
                    new MenuItem({
                        name: $translate.instant('navBar.kpis'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.maintenance.kpis' : 'secure.maintenance.kpissense'),
                        permissions: [permission.navbar.maintenance.dashboardRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MKPI],
                                    [products.PMKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    new MenuItem({
                        name: $translate.instant('navBar.forecast'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.maintenance.forecast' : 'secure.maintenance.forecastsense'),
                        permissions: [permission.navbar.maintenance.dashboardRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MKPI],
                                    [products.PMKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    new MenuItem({
                        name: $translate.instant('navBar.trends'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.maintenance.trendsForm' : 'secure.maintenance.trendsFormsense'),
                        permissions: [(!permission.navbar.kpiRead && permission.navbar.maintenance.trendsRead)],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MKPI],
                                    [products.PMKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    new MenuItem({
                        name: $translate.instant('navBar.maps'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.maintenance.mapsForm' : 'secure.maintenance.mapsFormsense'),
                        permissions: [permission.navbar.maintenance.mapsRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MKPI],
                                    [products.PMKPI]
                                ]
                            }
                        }
                    })
                ]),
                new MenuItem({
                    name: $translate.instant('navBar.inventory'),
                    icon: 'fa-barcode',
                    routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.inventoryForm' : 'secure.inventoryFormsense'),
                    permissions: [permission.navbar.kpiRead],
                    visibility: {
                        education: {
                            markets: markets.education,
                            products: [
                                [products.IND, products.COMMUNITY]
                            ]
                        },
                        nonEducation: {
                            markets: markets.nonEducation,
                            products: [
                                [products.IEI]
                            ]
                        }
                    }
                }),
                new MenuItem({
                    name: $translate.instant('navBar.events'),
                    icon: 'fa-calendar',
                    routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.events.kpis' : 'secure.events.kpissense'),
                    parentState: 'secure.events',
                    permissions: [permission.navbar.kpiRead],
                    visibility: {
                        education: {
                            markets: markets.education,
                            products: [
                                [products.FSD, products.COMMUNITY],
                                [products.FSKPI]
                            ]
                        }
                    }
                }).addChildren([
                    new MenuItem({
                        name: $translate.instant('navBar.dashboard'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.events.dashboardForm' : 'secure.events.dashboardFormsense'),
                        permissions: [permission.navbar.events.dashboardRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.FSKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    new MenuItem({
                        name: $translate.instant('navBar.execSummary'),
                        routerPath: 'secure.events.execSummaryForm',
                        permissions: [permission.navbar.events.executiveSummaryRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.FSKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    // Events dashboard read permission because KPI access is granted on the parent menuitem
                    new MenuItem({
                        name: $translate.instant('navBar.kpis'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.events.kpis' : 'secure.events.kpissense'),
                        permissions: [permission.navbar.events.dashboardRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.FSKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    new MenuItem({
                        name: $translate.instant('navBar.trends'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.events.trendsForm' : 'secure.events.trendsFormsense'),
                        permissions: [(!permission.navbar.events.dashboardRead && permission.navbar.events.trendsRead)],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.FSKPI]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }),
                    new MenuItem({
                        name: $translate.instant('navBar.maps'),
                        routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.events.mapsForm' : 'secure.events.mapsFormsense'),
                        permissions: [permission.navbar.events.mapsRead],
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.FSKPI]
                                ]
                            }
                        }
                    })
                ]),
                new MenuItem({
                    name: $translate.instant('navBar.technology'),
                    routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.technologyForm' : 'secure.technologyFormsense'),
                    permissions: [permission.navbar.kpiRead],
                    icon: 'fa-laptop',
                    visibility: {
                        education: {
                            markets: markets.education,
                            products: [
                                [products.ITD, products.COMMUNITY]
                            ]
                        },
                        nonEducation: {
                            markets: markets.nonEducation,
                            products: [
                                [products.ITD]
                            ]
                        }
                    }
                }),
                new MenuItem({
                    name: $translate.instant('navBar.trip'),
                    icon: 'fa-car',
                    routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.tripForm' : 'scure.tripFormsense'),
                    permissions: [permission.navbar.kpiRead],
                    visibility: {
                        education: {
                            markets: markets.education,
                            products: [
                                [products.TD, products.COMMUNITY]
                            ]
                        }
                    }
                }),
                new MenuItem({
                    name: $translate.instant('navBar.capitalForecast'),
                    icon: 'fa-line-chart',
                    routerPath: (localStorage.getItem('qlikCloudFlag') === 'true' ? 'secure.capitalForecastForm' : 'secure.capitalForecastFormsense'),
                    permissions: [permission.navbar.kpiRead],
                    visibility: {
                        education: {
                            markets: markets.education,
                            products: [
                                [products.CFD, products.COMMUNITY]
                            ]
                        },
                        nonEducation: {
                            markets: markets.nonEducation,
                            products: [
                                [products.AMP]
                            ]
                        }
                    }
                })
            ];

            if (hasFiles || hasVis) {
                var customItems = [];

                if (hasFiles) {
                    customItems.push(new MenuItem({
                        name: $translate.instant(hasVis ? 'navBar.myFiles' : 'navBar.custom'),
                        icon: 'fa-file-o',
                        routerPath: 'secure.myFilesForm',
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MD, products.COMMUNITY],
                                    [products.PMD, products.COMMUNITY]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }));
                }

                if (hasVis) {
                    custVis.forEach(function (vis) {
                        customItems.push(new MenuItem({
                            name: $translate.instant((hasFiles || custVis.length > 1) ? customVisualizationService.getDisplayName(vis.name) : 'navBar.custom'),
                            icon: 'fa-file-o',
                            routerPath: 'secure.customVisualizationForm({customVisualizationId: "' + vis.id + '"})',
                            visibility: {
                                education: {
                                    markets: markets.education,
                                    products: [
                                        [products.MD, products.COMMUNITY],
                                        [products.PMD, products.COMMUNITY]
                                    ]
                                },
                                nonEducation: {
                                    markets: markets.nonEducation,
                                    products: [
                                        [products.MEWO], [products.MEPM]
                                    ]
                                }
                            }
                        }));
                    });
                }

                if (customItems.length === 1) {
                    entireMenu.push(customItems[0]);
                } else {
                    entireMenu.push(new MenuItem({
                        name: $translate.instant('navBar.custom'),
                        icon: 'fa-file-o',
                        routerPath: 'secure.myFilesForm',
                        visibility: {
                            education: {
                                markets: markets.education,
                                products: [
                                    [products.MD, products.COMMUNITY],
                                    [products.PMD, products.COMMUNITY]
                                ]
                            },
                            nonEducation: {
                                markets: markets.nonEducation,
                                products: [
                                    [products.MEWO], [products.MEPM]
                                ]
                            }
                        }
                    }).addChildren(customItems));
                }
            }

            return entireMenu;
        };

        // lookup function to tell what visibility property to access
        var getVisiblityCategory = function (marketName) {
            return markets.nonEducation[marketName] ? 'nonEducation' : 'education';
        };

        /**
         * @ngdoc method
         * @name get
         * @methodOf navbar.navbarService
         * @description
         * A method used to get a navigation array for market and products.
         *
         * @param {object} market market name
         * @param {object} products products list
         * @param {object} permissions permissions list
         * @param {boolean} hasFiles has scheduledReports available
         * @param {array} custVis list of all custom visualizations
         * @returns {Array} navigation array for dude-navigation
         */

        var getNavigationArray = function (market, productsCollection, permissions, hasFiles, custVis) {
            return getEntireMenu(hasFiles, custVis).map(function (menuItem) {
                return menuItem.toNavigationItem(market, productsCollection, getVisiblityCategory(market), permissions);
            });
        };

        var getDefaultPage = function (navigationArray) {
            // find first navigation entry or first child navigation entry that user has permission to.
            if (navigationArray && navigationArray[0]) {
                var permissionCount = 0;
                for (var i = 0; i < navigationArray.length; i++) {
                    if (navigationArray[i].hasPermission) {
                        permissionCount++;
                        if (navigationArray[i].accordion) { // check dropdown items (children)
                            for (var j = 0; j < navigationArray[i].accordion.length; j++) {
                                if (navigationArray[i].accordion[j].hasPermission && navigationArray[i].accordion[j].routerPath) {
                                    return navigationArray[i].accordion[j].routerPath;
                                }
                            }
                        } else if (navigationArray[i].routerPath) { // if no children return the entry itself
                            return navigationArray[i].routerPath;
                        } else {
                            return '';
                        }
                    }
                }
                if (permissionCount < 1) {
                    return false;
                }
            } else { // navigation array is null or empty
                return false;
            }
            // eslint requirement: return consistency
            return false;
        };

        return {
            getNavigationArray: getNavigationArray,
            getDefaultPage: getDefaultPage
        };
    });


'use strict';

angular.module('navbar')
    .run(function ($rootScope, $window, appConfig) {
        $rootScope.$on('dudeError:NoSubscriptions', function (event, userMarket) {
            $window.location.href = appConfig.redirects.marketingPortal[userMarket.toLowerCase()];
        });
    });

/**
 * @ngdoc object
 * @name navbar.MenuItem
 *
 * @description
 * Class to be used to describe and build single navigation array entry
 *
 */

'use strict';
angular.module('navbar').service('MenuItem', function () {
    var MenuItem = function (description) {
        var self = this;
        var children = null;
        self.isVisible = false;
        self.hasPermission = false;

        self.addChildren = function (childrenArray) {
            children = childrenArray;
            return self;
        };

        var checkProducts = function (expectedProducts, actualProducts) {
            var result = false;
            var reduceCallback = function (compoundResult, product) {
                return compoundResult && !!actualProducts[product];
            };

            for (var i = 0; i < expectedProducts.length && !result; i++) {
                var productArray = expectedProducts[i];
                result = productArray.reduce(reduceCallback, true);
            }
            return result;
        };

        var checkPermissions = function (requiredPermissions, assignedPermissions) {
            if (!requiredPermissions || requiredPermissions.length === 0) {
                return true;
            }

            var result = false;
            var reduceCallback = function (compoundResult, permission) {
                return compoundResult && !!assignedPermissions[permission];
            };

            for (var i = 0; i < requiredPermissions.length && !result; i++) {
                result = requiredPermissions.reduce(reduceCallback, true);
            }
            return result;
        };

        var hasPermission = function (market, products, visibilityCategory, permissions) {
            if (!checkPermissions(description.permissions, permissions)) {
                return false;
            }
            if (description.visibility[visibilityCategory] && description.visibility[visibilityCategory].markets[market]) {
                return checkProducts(description.visibility[visibilityCategory].products, products);
            }
            return false;
        };

        /**
         * @ngdoc method
         * @name toNavigationItem
         * @methodOf navbar.MenuItem
         * @description
         * A method used convert the MenuItem instance to navigationArray item.
         *
         * @param {string} market market name
         * @param {object} products products dictionary
         * @param {string} visibilityCategory  name
         * @param {object} permissions permissions dictionary
         *
         * @returns {Object} A navigation array item in a format that is usable by dudeNavigation component
         */

        self.toNavigationItem = function (market, products, visibilityCategory, permissions) {
            var result = {
                name: description.name,
                routerPath: description.routerPath,
                icon: description.icon,
                hasPermission: hasPermission(market, products, visibilityCategory, permissions),
                type: 'navigation'
            };
            if (result.hasPermission && children) {
                var isAnyChildHasPermission = false;
                result.routerPath = description.parentState;
                result.accordion = children
                    .map(function (child) {
                        var innerResult = child.toNavigationItem(market, products, visibilityCategory, permissions);
                        if (innerResult.hasPermission) {
                            isAnyChildHasPermission = true;
                        }
                        delete innerResult.type;
                        return innerResult;
                    });

                if (!isAnyChildHasPermission) {
                    delete result.accordion;
                    result.routerPath = description.routerPath;
                }
            }
            return result;
        };
        return self;
    };
    return MenuItem;
});


'use strict';

angular.module('myFiles', ['ui.router', 'file', 'filterHelpers', 'dudeApi']);

/**
 * @ngdoc directive
 * @name myFiles.scheduledReport-file-row
 * @restrict E
 * @description
 *
 * Displays the a row of a list for a scheduledReport file
 *
 * @param {object} file the object containing all the information for the scheduledReport file
 *
 * <scheduledReport-file-row file='file'></scheduledReport-file-row>
 */

'use strict';

angular.module('myFiles')
    .component('scheduledReportFileRow', {
        bindings: {
            file: '='
        },
        templateUrl: 'app/components/myFiles/scheduledReportFileRow.html',
        controllerAs: 'scheduledReport'
    });

'use strict';

/**
 * @ngdoc service
 * @name myFiles.myFilesFilterService
 * @requires pagingHelpers
 *
 * @description
 * Service for supporting my files filters.
 *
 */
angular.module('myFiles')
    .factory('myFilesFilterService', function (pagingHelpers) {
        /**
         * @ngdoc method
         * @name getFilters
         * @methodOf myFiles.myFilesFilterService
         *
         * @description
         * Gets the currently active filter
         *
         * @param {object} params Hash of the filters that have been set by the user.
         * @returns {object} currentFilter Hash of the newly set filters.
         */
        var getFilters = function (params) {
            var currentFilter = {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Date desc'
            };

            return currentFilter;
        };

        /**
         * @ngdoc method
         * @name toApiFilter
         * @methodOf myFiles.myFilesFilterService
         *
         * @description
         * Converts the user-set filters from the page to an Api filter by using the getFilters method.
         *
         * @param {object} currentFilter Hash of the filters that have been set by the user.
         * @returns {object} getFilters Hash of the newly set filters.
         */
        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter
        };
    });

'use strict';

/**
 * @ngdoc service
 * @name myFiles.myFilesService
 * @requires DudeApi
 * @requires permission
 * @requires permissionsHelper
 * @requires userContext
 *
 * @description
 * Service for supporting My Files.
 *
 */
angular.module('myFiles')
    .service('myFilesService', function (DudeApi, permission, permissionsHelper, userContext) {
        /**
         * @ngdoc method
         * @name loadMyFiles
         * @methodOf myFiles.myFilesService
         *
         * @description
         * load my files list.
         *
         * @returns {object} My Files paged result
         */
        var loadMyFiles = function () {
            return DudeApi.AccountSettingsEntity.get({ id: 'DI-CustomVisualizationUsers' }).$promise.then(function (customVisualizationUsers) {
                if (permissionsHelper.userAllowed(permission.navbar.scheduledReportRead) && customVisualizationUsers.value
                    && (customVisualizationUsers.value.allowAll === true || customVisualizationUsers.value.users.indexOf(userContext.user.id) >= 0)) {
                    return DudeApi.ScheduledReportEntity.query().$promise.then(function (result) {
                        return result;
                    });
                }
                return { total: 0 };
            }, function () {
                return { total: 0 };
            });
        };

        return {
            loadMyFiles: loadMyFiles
        };
    });

'use strict';

angular.module('myFiles')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.myFilesForm', {
                url: 'myFiles?page',
                templateUrl: 'app/components/myFiles/myFiles.html',
                controller: 'MyFilesController',
                controllerAs: 'myFiles',
                feature: 'scheduledReports',
                resolve: {
                    scheduledReport: ['$q', '$stateParams', 'DudeApi', 'myFilesFilterService', function ($q, $stateParams, DudeApi, myFilesFilterService) {
                        var queryParams = $stateParams;
                        var filters = myFilesFilterService.getFilters(queryParams);
                        return $q.all({
                            initResponse: DudeApi.ScheduledReportEntity.query(filters).$promise,
                            filters: filters
                        });
                    }]
                }
            });
    });

'use strict';

angular.module('myFiles')
    .controller('MyFilesController', function ($scope, $translate, DudeApi, queryHelpers, scheduledReport, myFilesFilterService) {
        var self = this;
        self.test = true;

        self.totalCount = scheduledReport.initResponse.total;
        self.scheduledReports = scheduledReport.initResponse.data;
        self.filters = scheduledReport.filters;
        var queryDefaults = myFilesFilterService.getFilters({ type: self.filters.type });

        self.labelHeadings = {
            noResultsText: $translate.instant('myFiles.noFiles'),
            resultText: $translate.instant('myFiles.file'),
            resultsText: $translate.instant('myFiles.files')
        };

        var setData = function (response) {
            self.scheduledReports = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (angular.equals(oldVal, newVal)) {
                return;
            }

            DudeApi.ScheduledReportEntity.query(self.filters).$promise.then(setData);

            queryHelpers.updateState(newVal, queryDefaults);
        };

        $scope.$watch('myFiles.filters', updateFilters, true);
    });

'use strict';

angular.module('home', ['ui.router', 'dudeAuth', 'translate']);

'use strict';

angular.module('home')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.home', {
                url: 'home',
                templateUrl: 'app/components/home/home.html',
                controller: 'HomeController',
                controllerAs: 'home'
            });
    });

'use strict';

angular.module('home')
    .controller('HomeController', function () {
        // TODO: convert route logic to here from the nav controller
    });

'use strict';

angular.module('helpers', []);

'use strict';

angular.module('helpers')
    .service('utility', function () {
        var s4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        };

        var getUniqueId = function () {
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        };

        return {
            getUniqueId: getUniqueId
        };
    });

'use strict';

angular.module('helpers')
    .service('roleHelpers', function (permissionsHelper, permission) {
        var isRequester = function () {
            return !permissionsHelper.userAllowed(permission.workOrders.readAllDetails);
        };

        var isTechnician = function () {
            return !permissionsHelper.userAllowed(permission.users.create) && permissionsHelper.userAllowed(permission.workOrders.readAllDetails);
        };

        return {
            isRequester: isRequester,
            isTechnician: isTechnician
        };
    });

'use strict';

angular.module('helpers')
    .constant('permission', {
        workOrders: {
            create: 'WorkOrders-Create',
            read: 'WorkOrders-Read',
            update: 'WorkOrders-Update',
            receiveCreatedNotification: 'WorkOrders-ReceiveCreatedNotification',
            readAllDetails: 'WorkOrders-ReadAllDetails',
            createTasks: 'WorkOrders-CreateTasks',
            deleteTasks: 'WorkOrders-DeleteTasks'
        },
        users: {
            create: 'Users-Create',
            read: 'Users-Read',
            update: 'Users-Update'
        },
        pmSchedules: {
            create: 'PmSchedules-Create',
            read: 'PmSchedules-Read',
            update: 'PmSchedules-Update',
            delete: 'PmSchedules-Delete'
        },
        accounts: {
            create: 'Accounts-Create',
            read: 'Accounts-Read',
            update: 'Accounts-Update',
            delete: 'Accounts-Delete'
        },
        navbar: {
            kpiRead: 'KPI-Read',
            scheduledReportRead: 'ScheduledReport-Read',
            maintenance: {
                trendsRead: 'Trends-Read',
                mapsRead: 'Maps-Read',
                executiveSummaryRead: 'ExecutiveSummary-Read',
                dashboardRead: 'Dashboard-Read'
            },
            events: {
                trendsRead: 'EventsTrends-Read',
                mapsRead: 'EventsMaps-Read',
                executiveSummaryRead: 'EventsExecutiveSummary-Read',
                dashboardRead: 'EventsDashboard-Read'
            }
        }
    });

'use strict';

angular.module('helpers')
    .service('localStorageHelpers', function () {
        var ACCESS_KEYS = {
            LOCAL_STORAGE_MARKET_KEY: 'dsi.market',
            LOCAL_STORAGE_STATE_KEY: 'dsi.state',
            LOCAL_STORAGE_PRODUCTS_KEY: 'dsi.products'
        };

        /**
         * @description Fetches the user's "market" from local storage
         * @param {object} winder - $window object to delve
         * @returns {string} specific market value
         */
        var getMarket = function (winder) {
            return winder.localStorage.getItem(ACCESS_KEYS.LOCAL_STORAGE_MARKET_KEY);
        };

        /**
         * @description Fetches the account/user "state" postal code from local storage
         * @param {object} winder - $window object to delve
         * @returns {string} - returns associated value if it is registered
         */
        var getState = function (winder) {
            return winder.localStorage.getItem(ACCESS_KEYS.LOCAL_STORAGE_STATE_KEY);
        };

        /**
         * @description Fetches 'product' collection from local storage
         * @param {object} winder - window object to delve
         * @returns {string} - returns associated value if it is registered
         */
        var getProducts = function (winder) {
            return winder.localStorage.getItem(ACCESS_KEYS.LOCAL_STORAGE_PRODUCTS_KEY);
        };

        return {
            getMarket: getMarket,
            getProducts: getProducts,
            getState: getState
        };
    });

'use strict';

angular.module('helpers')
    .constant('commonMappings', {
        markets: {
            education: { K12: 'K12', HE: 'HE', IPS: 'IPS' },
            nonEducation: {
                MFG: 'MFG',
                HC: 'HC',
                SLCCRC: 'SLCCRC',
                SLIL: 'SLIL',
                SLAL: 'SLAL',
                SLSNF: 'SLSNF',
                HOSPITAL: 'HOSPITAL',
                BEHAVIORHEALTH: 'BEHAVIORHEALTH',
                OUTPATIENT: 'OUTPATIENT',
                CLUB: 'CLUB',
                GOV: 'GOV',
                FDOTHER: 'FDOTHER'
            }
        },
        products: {
            MD: 'MaintenanceDirect',
            COMMUNITY: 'MySchoolDude',
            PMD: 'PMDirect',
            IND: 'Inventory Direct',
            FSD: 'FSDirect',
            ITD: 'Incident',
            MEWO: 'Work Order',
            MKPI: 'Maintenance KPI',
            PMKPI: 'Preventative KPI',
            MEPM: 'Planned Maintenance',
            UD: 'UtilityDirect',
            TD: 'TripDirect',
            FSKPI: 'FacilitySchedulingKPI',
            UM: 'UtilityManager',
            UT: 'Utility Trac',
            AMP: 'Capital Forecast',
            CFD: 'Capital Forecast Direct',
            IEI: 'Inventory'
        },
        onlineDocURLs: {
            default: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Education/Dude%20Intelligence%20for%20Education%20Home.htm',
            K12: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Education/Dude%20Intelligence%20for%20Education%20Home.htm',
            HE: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Education/Dude%20Intelligence%20for%20Education%20Home.htm',
            IPS: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Education/Dude%20Intelligence%20for%20Education%20Home.htm',
            MFG: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Manufacturing/Dude%20Intelligence%20for%20Manufacturing%20Home.htm',
            HC: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            SLCCRC: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            SLIL: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            SLAL: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            SLSNF: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            HOSPITAL: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            BEHAVIORHEALTH: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            OUTPATIENT: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            CLUB: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            GOV: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm',
            FDOTHER: 'https://help.assetmanagement.siemens.com/help/Content/Documentation/Dude%20Intelligence/Govt-Healthcare-Clubs/Dude%20Intelligence%20for%20Govt-Healthcare-Clubs%20Home.htm'
        },
        GenericObjects: {
            whiteList: [
                'table',
                'barchart',
                'combochart',
                'treemap',
                'gauge',
                'listbox',
                'text-image',
                'piechart'
            ]
        },
        Events: {
            QLIK_APP_LOADED: 'qlik.app::loaded',
            QLIK_APP_SWITCH_SHEET: 'qlik.app::switch_sheet',
            QLIK_APP_FETCH_SHEET_WIDGETS_REQUEST: 'qlik-init:retrieve-widgets',
            QLIK_APP_FETCH_SHEET_WIDGETS_RESPONSE: 'qlik-init:retrieve-widgets-response',
            QLIK_APP_EXPORT_SHEET_WIDGETS_REQUEST: 'qlik-init:export-widgets',
            QLIK_APP_EXPORT_SHEET_WIDGETS_RESPONSE: 'qlik-init:export-widget-result'
        },
        Display: {
            qlikFrame: {
                height: 1000,
                width: '100%',
                qlikDashWidgetGrid: {
                    height: 1000,
                    width: '100%'
                }
            }
        }
    })
;

/**
 * @ngdoc service
 * @name helpers.browserVersion
 *
 * @description
 * Service for detection whether the browser is modern and suitable for application or not.
 *
 */

'use strict';

angular.module('helpers')
    .service('browserVersion', function ($window) {
        /**
         * @ngdoc method
         * @name isQlikCompatible
         * @methodOf helpers.browserVersion
         * @description
         * A method used to detect whether the browser is compatible to use Qlik.
         *
         * @returns {Object} true if browser version is compatible to use Qlik
         */

        var isQlikCompatible = function () {
            var userAgent = $window.navigator.userAgent;
            var ieDefinitionIndex = userAgent.indexOf('MSIE ');

            var result = true;
            if (ieDefinitionIndex > -1) {
                var ieVersion = userAgent.substring(ieDefinitionIndex + 5, userAgent.indexOf('.', ieDefinitionIndex));
                result = parseInt(ieVersion, 10) > 10;
            }

            return result;
        };

        return {
            isQlikCompatible: isQlikCompatible
        };
    });

'use strict';

angular.module('customVisualization', []);

'use strict';

/**
 * @ngdoc service
 * @name customVisualization.customVisualizationService
 * @requires $q
 * @requires $sce
 * @requires appConfig
 * @requires DudeApi
 * @requires localStorageService
 * @requires userContext
 *
 * @description
 * Service for supporting Custom Visualization.
 *
 */
angular.module('customVisualization')
    .service('customVisualizationService', function ($q, $sce, appConfig, DudeApi, localStorageService, userContext) {
        var cachedVisualizations;

        /**
         * @ngdoc method
         * @name getCustomVisualizationUrl
         * @methodOf customVisualization.customVisualizationService
         *
         * @description
         * Gets Custom Visualization Url.
         *
         * @param {string} id of viz
         * @returns {string} Custom Visualization Url
         */
        var getCustomVisualizationUrl = function (id) {
            return encodeURIComponent($sce.trustAsResourceUrl('https://' + appConfig.settings.qlikServerUri + '/platform/sense/app/' + id));
        };

        var getLocalStorageValue = function (key, callback, maxAttempts, delay) {
            maxAttempts = typeof maxAttempts !== 'undefined' ? maxAttempts : 5;
            delay = typeof delay !== 'undefined' ? delay : 5000;
            var deferred = $q.defer(); // AngularJS deferred object
            var attempts = 0;

            function tryGet() {
                var value = localStorage.getItem(key);
                if (value !== null) {
                    try {
                        var result = callback(value);
                        deferred.resolve(result);
                    } catch (err) {
                        deferred.reject(err);
                    }
                } else {
                    attempts++;
                    if (attempts < maxAttempts) {
                        setTimeout(tryGet, delay);
                    } else {
                        deferred.resolve(null); // or reject, based on your app logic
                    }
                }
            }

            tryGet();

            return {
                $promise: deferred.promise
            };
        };
        /**
         * @ngdoc method
         * @name securityVisuals
         * @methodOf customVisualization.customVisualizationService
         *
         * @description
         * Gets custom visualizations list for a security user.
         *
         * @returns {Promise} a promise that returns the paged result
         */
        var securityVisuals = function () {
            return DudeApi.AccountSettingsEntity.get({ id: 'DI-CustomVisualizationUsers' }).$promise
                .then(function (DICVUsers) {
                    if (DICVUsers.value && (DICVUsers.value.allowAll === true || DICVUsers.value.users.indexOf(userContext.user.id) >= 0)) {
                        var returnObject = {
                            data: []
                        };
                        return getLocalStorageValue('qlikCloudApps', JSON.parse).$promise.then(function (appQlik) {
                            appQlik.forEach(function (visual) {
                                var splittedVisualName = visual.name.split('-');
                                if (splittedVisualName[0].toLowerCase() !== 'cv') {
                                    return;
                                }
                                if (splittedVisualName[1] === userContext.account.id.toString()) {
                                    var visualObject = {
                                        id: visual.resourceId,
                                        name: visual.name
                                    };
                                    returnObject.data.push(visualObject);
                                }
                            });
                            return $q.resolve(returnObject.data);
                        });
                    }
                    return $q.resolve({ customVisualizations: [] });
                }).catch(function (err) {
                    return err;
                });
        };

        var loadCustomVisualizations = function () {
            var visualizationsPromise;
            if (cachedVisualizations) {
                visualizationsPromise = $q.resolve(cachedVisualizations);
            } else {
                visualizationsPromise = securityVisuals();
            }
            return visualizationsPromise;
        };

        /**
         * @ngdoc method
         * @name getCustomVisualization
         * @methodOf customVisualization.customVisualizationService
         *
         * @description
         * load a single custom visualization
         *
         * @param {string} id of viz
         * @returns {object} an object of data describing a single custom visualization
         */
        var getCustomVisualization = function (id) {
            return loadCustomVisualizations().then(function (vizs) {
                return vizs.filter(function (viz) {
                    return viz.id === id;
                })[0] || null;
            });
        };

        /**
         * @ngdoc method
         * @name machesNewPattern
         * @methodOf customVisualization.customVisualizationService
         * @description
         * Checks if the CV's name matches the new pattern that contains reload chain and sequence.
         *
         * @param {string} name of viz
         * @returns {boolean} true if the name matches the new pattern, false otherwise.
         */
        var machesNewPattern = function (name) {
            var nameRegex = /^[a-z]{2}-(?:([a-z]{1})(\d{3}))-.*$/i;
            return name.match(nameRegex);
        };

        /**
         * @ngdoc method
         * @name getDisplayName
         * @methodOf customVisualization.customVisualizationService
         *
         * @description
         * get display name.
         *
         * @param {string} name of viz
         * @returns {string} Display name
         */
        var getDisplayName = function (name) {
            var oldNameRegex = /(?:[^-\n]+-){2}(.*)$/;
            var newNameRegex = /(?:[^-\n]+-){3}(.*)$/;
            var nameRegex = machesNewPattern(name) ? newNameRegex : oldNameRegex;
            return nameRegex.exec(name)[1];
        };

        return {
            loadVisualizations: loadCustomVisualizations,
            getCustomVisualizationUrl: getCustomVisualizationUrl,
            getCustomVisualization: getCustomVisualization,
            getDisplayName: getDisplayName
        };
    });

'use strict';

angular.module('customVisualization')
    .config(function ($stateProvider) {
        $stateProvider
            .state('secure.customVisualizationForm', {
                url: 'customvisualization/:customVisualizationId',
                templateUrl: 'app/components/customVisualization/customVisualization.html',
                controller: 'CustomVisualizationController',
                controllerAs: 'cvController',
                resolve: {
                    customViz: function ($state, $stateParams, customVisualizationService) {
                        return customVisualizationService.getCustomVisualization($stateParams.customVisualizationId).then(function (result) {
                            return (result) || $state.go('secure.home');
                        });
                    }
                }
            });
    });

'use strict';

angular.module('customVisualization')
    .component('customVisualization', {
        bindings: {},
        templateUrl: 'app/components/customVisualization/customVisualization.html',
        controllerAs: 'cvController',
        controller: 'CustomVisualizationController'
    })
    .controller('CustomVisualizationController', function ($sce, customVisualizationService, customViz, appConfig) {
        var self = this;
        var generateCvUri = function (cvId) {
            var domain = appConfig.settings.qlikServerUri;
            var uri = appConfig.settings.qlikServerPrefix + domain + '/platform/sense/app/' + cvId;
            return uri;
        };

        self.viz = customViz; // or just uze this hard value (as string) : CV-1011-WFU Metrics
        self.displayName = customVisualizationService.getDisplayName(self.viz.name);
        self.src = $sce.trustAsResourceUrl(generateCvUri(self.viz.id));
        self.id = self.viz.id;
    });


'use strict';

angular.module('executiveSummary', ['ui.router', 'file', 'filterHelpers', 'dudeApi', 'helpers']);

/**
 * @ngdoc directive
 * @name executiveSummary.summary-file-row
 * @restrict E
 * @description
 *
 * Displays the a row of a list for a summary file
 *
 * @param {object} file the object containing all the information for the summary file
 *
 * <summary-file-row file='file'></summary-file-row>
 */

'use strict';

angular.module('executiveSummary')
    .component('summaryFileRow', {
        bindings: {
            file: '='
        },
        templateUrl: 'app/components/executiveSummary/summaryFileRow.html',
        controllerAs: 'summary'
    });

'use strict';

angular.module('executiveSummary')
    .factory('executiveSummaryFilterService', function (pagingHelpers) {
        var accountNumber = localStorage.getItem('dsi.systemOfRecordAccountNumber');
        var getFilters = function (params) {
            return {
                page: params.page || pagingHelpers.defaults.page,
                pageSize: params.pageSize || pagingHelpers.defaults.pageSize,
                orderBy: params.orderBy || 'Date desc',
                type: params.type || null,
                accountNumber: accountNumber
            };
        };

        var toApiFilter = function (currentFilter) {
            return getFilters(currentFilter);
        };

        return {
            getFilters: getFilters,
            toApiFilter: toApiFilter
        };
    });

'use strict';

angular.module('executiveSummary')
    .config(function ($stateProvider, permission) {
        var generateRoute = function (url, summaryType, permissionType) {
            return {
                url: url + '?page',
                templateUrl: 'app/components/executiveSummary/executiveSummary.html',
                permissions: [permissionType],
                controller: 'ExecutiveSummaryController',
                controllerAs: 'executiveSummary',
                resolve: {
                    summary: ['$q', '$stateParams', 'DudeApi', 'executiveSummaryFilterService', function ($q, $stateParams, DudeApi, executiveSummaryFilterService) {
                        var queryParams = $stateParams;
                        queryParams.type = summaryType;
                        var filters = executiveSummaryFilterService.getFilters(queryParams);
                        return $q.all({
                            initResponse: DudeApi.ExecutiveSummaryEntity.query(filters).$promise,
                            filters: filters
                        });
                    }]
                }
            };
        };

        $stateProvider
            .state('secure.maintenance.execSummaryForm', generateRoute('/execSummary', 'Maintenance', permission.navbar.maintenance.executiveSummaryRead))
            .state('secure.events.execSummaryForm', generateRoute('/execSummary', 'Event', permission.navbar.events.executiveSummaryRead));
    });

'use strict';

angular.module('executiveSummary')
    .controller('ExecutiveSummaryController', function ($scope, DudeApi, queryHelpers, $translate, summary, executiveSummaryFilterService) {
        var self = this;
        self.test = true;

        self.totalCount = summary.initResponse.total;
        self.summaries = summary.initResponse.data;
        self.filters = summary.filters;
        var queryDefaults = executiveSummaryFilterService.getFilters({ type: self.filters.type });

        self.labelHeadings = {
            noResultsText: $translate.instant('executiveSummary.noFiles'),
            resultText: $translate.instant('executiveSummary.file'),
            resultsText: $translate.instant('executiveSummary.files')
        };

        var setData = function (response) {
            self.summaries = response.data;
            self.totalCount = response.total;
        };

        var updateFilters = function (newVal, oldVal) {
            if (angular.equals(oldVal, newVal)) {
                return;
            }

            DudeApi.ExecutiveSummaryEntity.query(self.filters).$promise.then(setData);

            queryHelpers.updateState(newVal, queryDefaults);
        };

        $scope.$watch('executiveSummary.filters', updateFilters, true);
    });

'use strict';

angular.module('clearFilters', ['helpers']);

'use strict';

angular.module('clearFilters')
    .component('clearFilters', {
        bindings: {},
        templateUrl: 'app/components/clearFilters/clearFilters.html',
        controllerAs: 'clearFilters',
        controller: function ($rootScope, commonMappings) {
            var self = this;

            /**
             * @private
             * @type Window Scraper
             * @description Determines if a Listbox modal is open.
             * @returns {integer} length of found list box modal elements
             */
            var listBoxModalsPresent = function () {
                return angular.element(
                    angular.element('#qlik-frame')[0]
                        .contentDocument.body).find('.lui-popover-container').length;
            };

            self.disabled = true;
            /**
             * @type Qlik App Interface
             * @description Clears all applied, non-locked filters on a specific app, refer to Qlik App Capabilties API
             * found here:
             * https://help.qlik.com/en-US/sense-developer/June2018/Subsystems/APIs/Content/CapabilityAPIs/SelectionAPI/clearAll-method.html
             */
            self.clearFilters = function () {
                if (!self.app) {
                    // TODO throw here
                }
                if (!listBoxModalsPresent()) {
                    self.app.selectionState().clearAll(false);
                }
            };

            self.$onInit = function () {
            // REGION: Event Handlers
                /**
                 * @type Initialization Helper
                 * @description Listens for when the current Qlik App is ready, once ready it assigns the app to
                 * its internal app reference.
                 */
                var appLoaded = $rootScope.$on(commonMappings.Events.QLIK_APP_LOADED, function (event, loadedApp) {
                    self.app = loadedApp;
                    self.disabled = false;
                    appLoaded();
                });
            // END REGION
            };
        }
    });

'use strict';

angular.module('catalyst', [
    // App configuration information
    'catalystShared',

    // need these 2 for global configuration see. index.config.js
    'ui.router',
    'pascalprecht.translate',
    'ngSanitize',
    'spinner',
    'dudeAuth',
    'dudeApi',

    // DudeBase/DudeControls Global Modules
    'notification', // Toastr
    'dudeErrorPages',
    'dudeError', // DudeBase
    'utils',
    'filterHelpers',

    // Application
    'clearFilters',
    'customVisualization',
    'executiveSummary',
    'helpers',
    'home',
    'myFiles',
    'navbar',
    'qlikAccountNotFound',
    'qlikApp',
    'qlikDashboard',
    'qlikExporter',
    'qlikForm',
    'qlikTicket',
    'qlikVisualizationHelpers',
    'qlikWidgetHelpers'
]);

'use strict';

angular.module('catalyst')
    .controller('IndexController', function ($scope, browserVersion, appConfig, qlikVisualizations) {
        var self = this;
        // This Keeps the navbar and footer from prematurely loading before the user context.
        self.userContextLoaded = false;

        self.isBrowserQlikCompatible = browserVersion.isQlikCompatible();

        self.pendoOptions = null;

         // Load bootstrap.js from deploymentUrl
        var loadBootstrap = function () {
            if (!appConfig.deploymentUrl) {
                console.error('deploymentUrl missing from appConfig');
                return;
            }

            var script = document.createElement('script');
            script.src = appConfig.deploymentUrl + '/assets/js/bootstrap.min.js';

            script.onload = function () {
                console.log('Bootstrap loaded.');
            };

            script.onerror = function () {
                console.error('Failed to load Bootstrap.');
            };

            document.body.appendChild(script);
        };

        loadBootstrap();

        var setPendoOptions = function (userContext) {
            var _loaded = window.setInterval(function () {
                if (window.dudependo) {
                    window.dudependo('start', {
                        account: {
                            id: userContext.account.systemOfRecordAccount ?
                                userContext.account.systemOfRecordAccount.accountNumber : userContext.user.account.number,
                            market: userContext.account.market.name
                        },
                        additionalApiKeys: [appConfig.analytics.pendo.additionalApiKey]
                    });
                    window.clearInterval(_loaded);
                }
            }, 125);
        };

        var loadPendoAgent = function (userContext) {
            var market = qlikVisualizations.markets[userContext.account.market.name.toLowerCase()];
            var marketGroup = market ? market.marketGroup : null;
            var analyticsApiKey = marketGroup === 'education' ? appConfig.analytics.pendo.apiKeySd : appConfig.analytics.pendo.apiKeyFd;
            var snippetLocation = '//' + appConfig.analytics.pendo.pendoHostname + '/agents/latest.js';

            (function (win, doc, tag, dudePendoVariable, jsSource, apiKey, e, s) {
                win.DudePendoAgentConfig = dudePendoVariable;
                (win[dudePendoVariable] =
                    win[dudePendoVariable] ||
                    function () {
                        (win[dudePendoVariable].q = win[dudePendoVariable].q || []).push(arguments);
                    }).key = apiKey;
                e = doc.createElement(tag);
                s = doc.getElementsByTagName(tag)[0];
                e.async = 1;
                e.src = jsSource;
                s.parentNode.insertBefore(e, s);
            }(window, document, 'script', 'dudependo', snippetLocation, analyticsApiKey));
        };

        $scope.$on('dudeAuth:user-loaded', function (event, userContext) {
            loadPendoAgent(userContext);
            setPendoOptions(userContext);
            self.userContextLoaded = true;
        });
    });

'use strict';

angular.module('catalyst')
    .config(function ($urlRouterProvider, $translateProvider, appConfig, dudeApiConfigProvider, loginRedirectorProvider, $sceDelegateProvider) {
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy(null);
        loginRedirectorProvider.clientId = appConfig.settings.clientId;
        loginRedirectorProvider.scopes = appConfig.settings.scopes;
        loginRedirectorProvider.ignoreState = appConfig.settings.ignoreState;
        loginRedirectorProvider.loginRedirectUrl = null;
        $urlRouterProvider.otherwise(function ($injector, $location) {
            var path = $location.path();
            // Stops the loop-de loop
            if (path === '/' || path === '') {
                $injector.get('$state').transitionTo('secure.home');
            }
        });

        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain. **.
            'https://intelligence-master.dudesoln.com/**',
            'https://intelligence-master.dudesoln.com/**',
            'https://qlik.cloud.domain/**'
        ]);

        // set urls
        dudeApiConfigProvider.baseUrl = appConfig.api.core;
        dudeApiConfigProvider.securityUrl = appConfig.api.security;
        dudeApiConfigProvider.fileUrl = appConfig.api.file;
        dudeApiConfigProvider.reportUrl = appConfig.api.report;
        dudeApiConfigProvider.qlikThenticatorClassicUrl = appConfig.api.qlik;
        dudeApiConfigProvider.intelligenceUrl = appConfig.api.intelligence;
        dudeApiConfigProvider.settingsUrl = appConfig.api.settings;
        dudeApiConfigProvider.pendoUrl = appConfig.api.pendo;
    })
    .run(function ($rootScope, $log, $window, $q, notification, marketizr, dudeGuid, appConfig, log, $exceptionHandler, $translate, spinnerService, $http) {
        // Configure the notifications service
        // for toastr messages
        notification.init();
        // Listen for the user context to load and create a base remote logger object
        // This will be used to send info to new relic

        var getAllItems = function (data) {
            var userId = data.userId;
            var authToken = localStorage.getItem('auth.access_token').replace(/"/g, '');
            if (localStorage.getItem('qlikCloudFlag') !== 'false') { // This is to check on the Feature Flag, if it's set to False then we try not to modify it
                $window.localStorage.setItem('qlikCloudFlag', data.qlikCloudFlag);
            }

            var bodyItem = {
                JWTToken: userId
            };
            $http.post('http://login.localtest.me/users/me/qlikaccesstoken', bodyItem, {
                redirect: 'follow',
                headers: {
                    'Content-Type': 'application/json; charset=utf8',
                    Authorization: 'Bearer ' + authToken
                }
            }).then(function (responseResp) {
                var apiUrl = 'https://qlik.cloud.domain/api/v1/items?limit=100&spaceId=' + appConfig.spaceId;
                var authTokenResp = responseResp.data;
                var config = {
                    headers: {
                        Authorization: 'Bearer ' + authTokenResp,
                        'content-type': 'application/json'
                    }
                };
                $http.get(apiUrl, config)
                     .then(function (response) {
                         // Handle the API response data
                         var listedSpaceItems = [];
                         response.data.data.forEach(function (item) {
                             var spaceItem = {
                                 name: item.name,
                                 spaceId: item.spaceId,
                                 resourceId: item.resourceId
                             };
                             listedSpaceItems.push(spaceItem);
                         });
                         $window.localStorage.setItem('qlikCloudApps', JSON.stringify(listedSpaceItems));
                     });
            });
        };

        var baseLogObj = {};
        $rootScope.$on('dudeAuth:user-loaded', function (event, data) {
            baseLogObj = {
                accountDbId: data.account.id, // accountId breaks new relic
                accountNumber: data.account.number,
                accountName: data.account.name,
                asset: data.account.assets || 'Catalyst',
                userId: data.user.id,
                userEmail: data.user.email,
                jwtToken: data.user.jwtToken,
                qlikCloudFlag: data.user.qlikCloudFlag
            };
            getAllItems(baseLogObj);
        });

        // Initiate the export of the image, promise chain the 'spinner'
        // then reach back down into the Qlik angular context and emit
        // the next event
        var beginImageExport = function (data) {
            var request = {
                headers: {
                    Accept: 'application/json'
                }
            };
            return $q(function (resolve) {
                resolve(spinnerService.show(request));
            }).then(function () {
                return $q(function (resolve) {
                    resolve($window.angular.element('#qlik-frame')[0].contentWindow.angular.element('body').scope().$emit('spinnerShowing', data));
                });
            });
        };

        // setup listener for `remote` errors that need to be logged to new relic
        $rootScope.$on('dudeLog:remote', function (event, data) {
            if ($window.newrelic) {
                // Check if data coming in is not an object and convert it
                if (!angular.isObject(data)) {
                    data = {
                        message: data
                    };
                }
                // Generate a guid
                baseLogObj.dudeReferenceId = dudeGuid.generate();
                var actionData = angular.extend(baseLogObj, data);
                $window.newrelic.addPageAction('DudeError', actionData);
            }
        });

        // we listen on this scope because dude-controls-shell is not injected into the qlik context
        $rootScope.$on('showSpinner', function (event, data) {
            beginImageExport(data);
        });

        $rootScope.$on('hideSpinner', function () {
            return $q(function (resolve) {
                resolve(spinnerService.hide());
            }).then(function () {
                // something happens with the spinner $watcher, it stops watching.
                // this ensures the hide() update is noticed by forcing the digest
                $rootScope.$apply();
            });
        });

        $rootScope.$on('dudeLog:XLSXportSuccess', function () {
            log.notify({
                allowHtml: true,
                type: 'success',
                title: $translate.instant('dataExport.xlsx.success.toast.title'),
                message: $translate.instant('dataExport.xlsx.success.toast.description')
            });
        });

        $rootScope.$on('dudelog:XLSXportFailure', function (event, error) {
            log.notify({
                type: 'error',
                title: $translate.instant('dataExport.xlsx.failure.toast.title'),
                message: $translate.instant('dataExport.xlsx.failure.toast.description')
            });
            $exceptionHandler(error);
        });

        $rootScope.$on('dudeLog:qlikFrameError', function (event, error) {
            $exceptionHandler(error);
        });

        $rootScope.$on('$stateChangeSuccess', function () {
            $window.document.body.scrollTop = $window.document.documentElement.scrollTop = 0;
        });

        $rootScope.$on('$stateChangeError', function () {
            $log.log(arguments);
        });

        $rootScope.analytics = appConfig.analytics;
    });

'use strict';

angular.module('catalystShared', []);

'use strict';

angular.module('catalystShared')
    .constant('appConfig', {
        api: {
            core: /* DudeApiUri */ 'http://vnext.api.localtest.me' /* DudeApiUri */,
            file: /* DudeFileUri */ 'http://vnext.file.localtest.me' /* DudeFileUri */,
            intelligence: /* DudeIntelligenceUri */ 'http://vnext.intelligence.localtest.me' /* DudeIntelligenceUri */,
            pendo: /* DudePendoUri */ 'http://vnext.pendoagent.localtest.me' /* DudePendoUri */,
            qlik: /* DudeQlikthenticatorClassicUri */ 'http://vnext.qlik.localtest.me' /* DudeQlikthenticatorClassicUri */,
            qlikthenticator: /* DudeQlikthenticatorUri */ 'http://vnext.qlikthenticator.localtest.me:5150' /* DudeQlikthenticatorUri */,
            report: /* DudeFileUri */ 'http://vnext.report.localtest.me' /* DudeFileUri */,
            security: /* DudeOauthUri */ 'http://login.localtest.me' /* DudeOauthUri */,
            settings: /* DudeSettingsUri */ 'http://vnext.settings.localtest.me' /* DudeSettingsUri */
        },
        analytics: {
            pendo: {
                pendoHostname: /* PendoHost */ '' /* PendoHost */,
                apiKeyFd: /* PendoApiKeyFD */ '' /* PendoApiKeyFD */,
                apiKeySd: /* PendoApiKeySD */ '' /* PendoApiKeySD */,
                productName: /* PendoProductName */ 'DI' /* PendoProductName */,
                additionalApiKey: /* PendoAdditionalApiKey */ '' /* PendoAdditionalApiKey */
            }
        },
        settings: {
            clientId: 'intelligence',
            ignoreState: true,
            securityLogoutUri: 'https://dudesolutions.com/mylogin',
            identityClientId: 'Intelligence.ClientId.local',
            scopes: ['qlik', 'users', 'profile', 'openid', 'email', 'phone', 'address'],
            qlikServerUri: /* QlikServerUri */ 'bi.dudesolutions.com' /* QlikServerUri */,
            qlikServerPort: /* QlikServerPort */ '443' /* QlikServerPort */,
            qlikServerPrefix: /* QlikServerPrefix */ 'https://' /* QlikServerPrefix */,
            pathToBeaconImg: /* QlikBeaconPath */ '/platform/resources/img/core/noise_16x16.png' /* QlikBeaconPath */,
            liveAgentAccountId: /* LiveAgentAccountId */ '57337000000GrCE' /* LiveAgentAccountId */
        },
        qlikApplications: {
            energy: 'DI-Energy',
            utilities: 'DI-Energy',
            events: 'DI-Events',
            inventory: 'DI-Inventory',
            maintenance: 'DI-Maintenance',
            technology: 'DI-Technology',
            trips: 'DI-Trips',
            capitalForecast: 'DI-Capital',
            forecast: 'DI-Maintenance-DASH_Forecast',
            maps: 'DI-Comparative Maps'
        },
        qlikDashboardApplications: {
            education: 'DI-Maintenance-DASH_EDU',
            manufacturing: 'DI-Maintenance-DASH_MFG',
            government: 'DI-Maintenance-DASH_GOV',
            membership: 'DI-Maintenance-DASH_MEM',
            forecast: 'DI-Maintenance-DASH_Forecast',
            others: 'DI-Maintenance-DASH_MEM',
            events: 'DI-Events-DASH'
        },
        qlikApplicationsSense: {
            energy: 'DI-Energy',
            utilities: 'DI-Energy',
            events: 'DI-Events',
            inventory: 'DI-Inventory',
            maintenance: 'DI-Maintenance',
            technology: 'DI-Technology',
            trips: 'DI-Trips',
            capitalForecast: 'DI-Capital',
            forecast: 'DI-Maintenance-DASH_Forecast',
            maps: 'DI-Comparative Maps'
        },
        qlikDashboardApplicationsSense: {
            education: 'DI-Maintenance-DASH_EDU',
            manufacturing: 'DI-Maintenance-DASH_MFG',
            government: 'DI-Maintenance-DASH_GOV',
            membership: 'DI-Maintenance-DASH_MEM',
            others: 'DI-Maintenance-DASH_MEM',
            events: 'DI-Events-DASH'
        },
        redirects: {
            marketingPortal: {
                sd: 'https://www.dudesolutions.com/app/edu-dudeintelligence',
                fd: 'http://www.dudesolutions.com/inapp/dudeintelligence'
            }

        },
        spaceId: 'QlikEmbed.Space.Id',
        orgId: /* QlikCloudOrgID */ 'QlikCloud.OrgID' /* QlikCloudOrgID */,
        deploymentUrl: /* DeploymentUrl */ 'QlikCloud.DeploymentUrl' /* DeploymentUrl */,
        scrt2URL: /* Scrt2URL */ 'QlikCloud.Scrt2URL' /* Scrt2URL */
    });


angular.module("translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {
    "clearFilters": {
        "clearAll": "Clear All Filters"
    }
}
);

$translateProvider.translations("en", {
    "customVisualization": {
        "noIframeSupport": "Your browser does not support iframes."
    }
}
);

$translateProvider.translations("en", {
    "executiveSummary": {
        "title": "Executive Summary",
        "posted": "Posted",
        "at": "at",
        "mostRecent": "Most Recent",
        "summaryHistory": "Summary History",
        "noFilesFound": "No Files Found",
        "noFiles": "No Files",
        "file": "File",
        "files": "Files"
    }
}
);

$translateProvider.translations("en", {
    "home": {
        "home": "Home",
        "title": "Project Catalyst",
        "message": "Welcome to your new Dude Application"
    }
}
);

$translateProvider.translations("en", {
    "myFiles": {
        "title": "My Files",
        "posted": "Posted",
        "at": "at",
        "mostRecent": "Most Recent",
        "scheduledReportHistory": "Report History",
        "noFilesFound": "No Files Found",
        "noFiles": "No Files",
        "file": "File",
        "files": "Files"
    }
}
);

$translateProvider.translations("en", {
    "navBar": {
        "title": "Dude Intelligence",
        "product": "Catalyst",
        "mainNav": "Main Navigation",
        "toggleNav": "Toggle Navigation",
        "accountSettings": "Account Settings",
        "configurations": "Configurations",
        "userSettings": "User Settings",
        "editProfile": "Edit Profile",
        "changePassword": "Change Password",
        "notificationSettings": "Notification Settings",
        "logout": "Logout",
        "home": "Home",
        "maintenance": "Maintenance",
        "inventory": "Inventory",
        "dashboard": "Dashboard",
        "kpis": "KPIs",
        "trends": "Trends",
        "maps": "Maps",
        "events": "Events",
        "technology": "Technology",
        "utilities": "Utilities",
        "capitalForecast": "Capital Forecast",
        "forecast": "Forecast",
        "trip": "Trip",
        "execSummary": "Exec Summary",
        "myFiles": "My Files",
        "custom": "Custom",
        "visualizations": "Visualizations",
        "userManagement": "User Access Management"
    },
    "helpDropdown": {
        "email": {
            "title": "mailto:ams-support.si@siemens.com?subject=DudeIntelligence",
            "address": "ams-support.si@siemens.com"
        },
        "phone": {
            "phoneDisplay": "1-877-655-3833",
            "phoneHref": "tel:18776553833"
        }
    }
}
);

$translateProvider.translations("en", {
  "qlikAccountNotFound": {
    "header": "Oops!",
    "subHeader": "No Data Found",
    "message": "We were unable to find any data for your account. If you think this is incorrect, please reach out to our client support team.",
    "newClientMessage": "If you are a new client, please be patient as we build your data visualizations."
  }
}
);

$translateProvider.translations("en",     {
    "exporter": {
        "export": "Export",
        "help": "Select the visualizations you would like to export to excel spreadsheets.",
        "selectAll": "Select All"
    }
}
);

$translateProvider.translations("en", {
    "qlikForm": {
        "categories": {
            "volume" : "Volume",
            "efficiency" : "Efficiency",
            "dataQuality" : "Data Quality"
        }
    }
}
);

$translateProvider.translations("en", {
    "general": {
        "filters": "Filters",
        "sort": "Sort",
        "all": "All",
        "result": "Result",
        "results": "Results",
        "noResults": "No Results",
        "actionsText": "Actions",
        "edit": "Edit",
        "refineBy": "Refine By",
        "viewDetails": "View Details",
        "inactive": "Inactive",
        "active": "Active",
        "required": "Required",
        "search": "Search",
        "close": "Close",
        "selectAll": "Select All",
        "unselectAll": "Unselect All",
        "clearAll": "Clear All",
        "disabled": "Disabled",
        "notActivated": "Not Activated",
        "at": "at",
        "actions": {
            "new": "New",
            "add": "Add",
            "save": "Save",
            "saveAndNext": "Save & Next",
            "saveAndEdit": "Save & Keep Editing",
            "saveAndFinish": "Save & Finish",
            "delete": "Delete",
            "cancel": "Cancel",
            "close": "Close",
            "ok": "Ok",
            "yes": "Yes",
            "no": "No",
            "back": "Back"
        },
        "validation": {
            "required": "Required",
            "email": "Invalid Email",
            "emailAlreadyExists": "Email address already exists",
            "timeEmpty": "Please enter a time"
        },
        "abbreviations": {
            "hours": "hrs",
            "hour": "hr"
        }
    },
    "dataExport": {
        "xlsx": {
            "success": {
                "toast": {
                    "title": "Export Successful",
                    "description": "If your file(s) has not automatically downloaded, please disable your popup blocker."
                }
            },
            "failure": {
                "toast" : {
                    "title": "Export Failed",
                    "description": "An error was encountered while downloading your data. Please try again later, thank you."
                }
            }
        }
    }
}
);
}]);

'use strict';

// The dependencies for translate must be declared in this order or translations will fail in testing declaring $translateProvider undefined.
// So the angular translate dependency 'pascalprecht.translate' must be declared first.
angular.module('translate', ['pascalprecht.translate', 'translations']);

angular.module("catalystShared").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/clearFilters/clearFilters.html","<button class=\"btn btn-primary control\" ng-click=clearFilters.clearFilters()>{{\'clearFilters.clearAll\' | translate}}</button>");
$templateCache.put("app/components/customVisualization/customVisualization.html","<script crossorigin=anonymous type=application/javascript src=https://cdn.jsdelivr.net/npm/@qlik/embed-web-components/dist/index.min.js data-host=qlik.cloud.domain data-client-id=QlikEmbed.ClientID data-get-access-token=getAccessToken data-auth-type=Oauth2></script><style>iframe {\r\n        height: 1024px !important;\r\n        position: static !important;\r\n    }</style><script>var userId = localStorage.getItem(\"dsi.userId\");\r\n    var authToken = localStorage.getItem(\"auth.access_token\").replace(/\"/g, \'\');\r\n    \r\n    var bodyItem = {\r\n      \"JWTToken\": userId\r\n    }\r\n    async function getAccessToken() {\r\n        var response = await fetch(\"http://login.localtest.me/users/me/qlikaccesstoken\", {\r\n        method: \"POST\",\r\n        redirect: \"follow\",\r\n        body: JSON.stringify(bodyItem),\r\n        headers: {\r\n              \"Content-Type\": \"application/json; charset=utf8\",\r\n              \"Authorization\": \"Bearer \" + authToken\r\n          }\r\n      });\r\n      if (response.status === 200) {\r\n        return response.text();\r\n      }\r\n      var err = new Error(\"Unexpected serverside authentication error\");\r\n      err.status = response.status;\r\n      err.detail;\r\n      throw err;\r\n    }</script><div class=\"qlik-dashboard scope container\"><div class=row><div class=col-md-12><h5>{{:: cvController.displayName}}</h5></div></div><div class=content-section id={{cvController.id}}><qlik-embed ui=classic/app app-id={{cvController.id}} theme-id=\"Brightly Wide Palette 2.0\"></qlik-embed><!-- <iframe width=\"100%\" height=\"1000\" ng-src=\"{{cvController.src}}\" id=\"qlik-frame\" frameborder=\"0\">\r\n            <p>im not working</p>\r\n        </iframe> --></div></div>");
$templateCache.put("app/components/executiveSummary/executiveSummary.html","<div class=ng-scope><div class=\"row header-container\"><div class=col-xs-12><h4>{{::\'executiveSummary.title\' | translate}}<results-message total=executiveSummary.totalCount labels=executiveSummary.labelHeadings class=hidden-xs></results-message></h4></div></div><div class=main-container><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><div class=no-results ng-if=\"executiveSummary.summaries.length === 0\"><h6><em class=text-muted>{{::\'executiveSummary.noFilesFound\' | translate}}</em></h6></div><div ng-if=\"executiveSummary.summaries.length > 0\"><div class=most-recent-summary ng-if=\"executiveSummary.filters.page === 1\"><h6 class=font-secondary>{{::\'executiveSummary.mostRecent\' | translate}}</h6><summary-file-row file=executiveSummary.summaries[0]></summary-file-row></div><div ng-if=\"executiveSummary.summaries.length > 1\"><h6 class=\"font-secondary summary-history-title\">{{::\'executiveSummary.summaryHistory\' | translate}}</h6><div class=\"summary-file-row border-bottom\" ng-repeat=\"summary in executiveSummary.summaries\" ng-if=\"executiveSummary.filters.page > 1 || $index > 0\"><summary-file-row file=summary></summary-file-row></div></div></div><div class=row ng-hide=\"executiveSummary.totalCount <= executiveSummary.filters.pageSize\"><div class=col-sm-12><ul uib-pagination total-items=executiveSummary.totalCount ng-model=executiveSummary.filters.page items-per-page=executiveSummary.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" boundary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/components/executiveSummary/summaryFileRow.html","<div class=font-secondary><div class=media><div class=media-left><i class=\"fa fa-file-powerpoint-o fa-3x media-object\"></i></div><div class=\"media-body summary-file-body\"><div><a ng-href={{::summary.file.shareableUri}} target=_blank>{{::summary.file.name}}</a> <span>{{::summary.file.size | bytes}}</span></div><em><span>{{::\'executiveSummary.posted\' | translate}}</span> <span>{{::summary.file.date | date:\'MM/dd/yyyy\'}}</span> <span>{{::\'executiveSummary.at\' | translate}}</span> <span>{{::summary.file.date | date:\'hh:mm a\'}}</span></em></div></div></div>");
$templateCache.put("app/components/home/home.html","");
$templateCache.put("app/components/myFiles/myFiles.html","<div class=ng-scope><div class=\"row header-container\"><div class=col-xs-12><h4>{{::\'myFiles.title\' | translate}}<results-message total=myFiles.totalCount labels=myFiles.labelHeadings class=hidden-xs></results-message></h4></div></div><div class=\"main-container my-files\"><div class=row><div class=list-body><div class=\"col-xs-12 content-body content-section\"><div class=no-results ng-if=\"myFiles.scheduledReports.length === 0\"><h6><em class=text-muted>{{::\'myFiles.noFilesFound\' | translate}}</em></h6></div><div ng-if=\"myFiles.scheduledReports.length > 0\"><div class=most-recent-scheduled-report ng-if=\"myFiles.filters.page === 1\"><h6 class=font-secondary>{{::\'myFiles.mostRecent\' | translate}}</h6><scheduled-report-file-row file=myFiles.scheduledReports[0]></scheduled-report-file-row></div><div ng-if=\"myFiles.scheduledReports.length > 1\"><h6 class=\"font-secondary scheduled-report-history-title\">{{::\'myFiles.scheduledReportHistory\' | translate}}</h6><div class=\"scheduled-report-file-row border-bottom\" ng-repeat=\"scheduledReport in myFiles.scheduledReports\" ng-if=\"myFiles.filters.page > 1 || $index > 0\"><scheduled-report-file-row file=scheduledReport></scheduled-report-file-row></div></div></div><div class=row ng-hide=\"myFiles.totalCount <= myFiles.filters.pageSize\"><div class=col-sm-12><ul uib-pagination total-items=myFiles.totalCount ng-model=myFiles.filters.page items-per-page=myFiles.filters.pageSize max-size=5 class=\"pagination-sm pull-right\" boundary-links=false rotate=true scroll-to-top></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/components/myFiles/scheduledReportFileRow.html","<div class=\"font-secondary my-files\"><div class=media><div class=media-left><i ng-class=\"{ \'fa-file-powerpoint-o\' : scheduledReport.file.name.indexOf(\'.pptx\') > -1,\n                    \'fa-file-excel-o\' : scheduledReport.file.name.indexOf(\'.xlsx\') > -1,\n                    \'fa-file-pdf-o\' : scheduledReport.file.name.indexOf(\'.pdf\') > -1}\" class=\"fa fa-3x media-object\"></i></div><div class=\"media-body scheduled-report-file-body\"><div><a ng-href={{::scheduledReport.file.shareableUri}} target=_blank>{{::scheduledReport.file.name}}</a> <span>{{::scheduledReport.file.size | bytes}}</span></div><em><span>{{::\'myFiles.posted\' | translate}}</span> <span>{{::scheduledReport.file.date | date:\'MM/dd/yyyy\'}}</span> <span>{{::\'myFiles.at\' | translate}}</span> <span>{{::scheduledReport.file.date | date:\'hh:mm a\'}}</span></em></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=dude-intelligence-container ng-controller=\"NavbarController as navBar\"><dude-navigation navigation-title=navBar.title help-menu=navBar.support navigation-search=navBar.search navigation=navBar.navigationArray options=navBar.options ng-if=navBar.profile></dude-navigation></div>");
$templateCache.put("app/components/qlikAccountNotFound/qlikAccountNotFound.html","<div class=container><div class=row><div class=col-md-12><div class=\"text-center jumbotron\"><h1>{{::\'qlikAccountNotFound.header\' | translate}}</h1><h2>{{::\'qlikAccountNotFound.subHeader\' | translate}}</h2><h4>{{::\'qlikAccountNotFound.message\' | translate}}</h4><h4>{{::\'qlikAccountNotFound.newClientMessage\' | translate}}</h4><div class=error-cta><a href=\"mailto:{{::\'errorPages.email\' | translate}}?subject={{::\'errorPages.subject\' | translate}} - {{::qlikAccountNotFound.profile.account.number}}&body={{::\'errorPages.supportMessage\' | translate}}: {{::qlikAccountNotFound.refId}}\" class=\"btn btn-primary btn-lg error-action-button\"><i class=\"fa fa-envelope\"></i> {{::\'errorPages.contact\' | translate}}</a></div></div></div></div></div>");
$templateCache.put("app/components/qlikDashboard/qlikDashboard.html","<script crossorigin=anonymous type=application/javascript src=https://cdn.jsdelivr.net/npm/@qlik/embed-web-components/dist/index.min.js data-host=qlik.cloud.domain data-client-id=QlikEmbed.ClientID data-get-access-token=getAccessToken data-auth-type=Oauth2></script><style>iframe {\r\n        height: 1024px !important;\r\n        position: static !important;\r\n    }</style><script>var userId = localStorage.getItem(\"dsi.userId\");\r\n    var authToken = localStorage.getItem(\"auth.access_token\").replace(/\"/g, \'\');\r\n    \r\n    var bodyItem = {\r\n      \"JWTToken\": userId\r\n    }\r\n    async function getAccessToken() {\r\n        var response = await fetch(\"http://login.localtest.me/users/me/qlikaccesstoken\", {\r\n        method: \"POST\",\r\n        redirect: \"follow\",\r\n        body: JSON.stringify(bodyItem),\r\n        headers: {\r\n              \"Content-Type\": \"application/json; charset=utf8\",\r\n              \"Authorization\": \"Bearer \" + authToken\r\n          }\r\n      });\r\n      if (response.status === 200) {\r\n        return response.text();\r\n      }\r\n      var err = new Error(\"Unexpected serverside authentication error\");\r\n      err.status = response.status;\r\n      err.detail;\r\n      throw err;\r\n    }</script><div class=\"qlik-dashboard scope container\"><div class=row><div class=col-md-10><h5>{{:: qlikDashboard.title}}</h5></div></div><div class=\"content-section embedcontainer\" ng-attr-width=\"{{::qlikDashboard.width }}\" ng-attr-height=\"{{::qlikDashboard.height + \'px\'}}\" id=qlik-frame><!-- <div class=\"dashboard-controls pull-right\">\r\n            <qlik-exporter class=\"control\" app=\"qlikDashboard.appName\"\r\n                           sheet=\"qlikDashboard.selectedSheet\"></qlik-exporter>\r\n            <clear-filters></clear-filters>\r\n        </div> --><qlik-embed ui=classic/app app-id={{qlikDashboard.appName}} theme-id=\"Brightly Wide Palette 2.0\"></qlik-embed><!-- <iframe ng-attr-width=\"{{::qlikDashboard.width }}\" ng-attr-height=\"{{::qlikDashboard.height + \'px\'}}\" ng-src=\"{{qlikDashboard.appName}}\" id=\"qlik-frame\"\r\n                frameborder=\"0\" class=\"{{ qlikDashboard.targetMarket }}\">\r\n            <p>Your browser does not support iframes.</p>\r\n        </iframe> --></div></div>");
$templateCache.put("app/components/qlikApp/qlikApp.html","<div ng-switch=$parent.qlikInit.windowContext.appType class=non-dashboard><qlik-dash ng-switch-when=dashboard></qlik-dash><div ng-switch-when=maps><qlik-app-maps></qlik-app-maps></div><div ng-switch-when=CV><qlik-cv></qlik-cv></div><qlik-app-widgets ng-switch-default></qlik-app-widgets></div>");
$templateCache.put("app/components/qlikExporter/qlikExporter.html","<button class=\"btn btn-primary\" ng-click=qlikExporter.openExportPanel()>{{::\'exporter.export\' | translate}}</button><sliding-panel button-functions=qlikExporter.functions cancel-button=true open-when=qlikExporter.exportPanelOpen titles=qlikExporter.titles><panel-body><div class=panel-form-content><p>{{::\'exporter.help\' | translate }}</p><div class=checkbox><label><input type=checkbox ng-model=qlikExporter.selectAll ng-change=qlikExporter.onSelectAllChange()>{{::\'exporter.selectAll\' | translate}}</label></div><ul class=input-group><li class=checkbox ng-repeat=\"widget in qlikExporter.widgets\"><label><input type=checkbox value={{widget.id}} ng-model=widget.selected>{{widget.title}}</label></li></ul></div></panel-body></sliding-panel>");
$templateCache.put("app/components/qlikForm/qlikForm.html","<div class=ng-scope><div class=\"main-container page-title\" ng-if=qlikForm.title><h5>{{:: qlikForm.title}}</h5></div></div><iframe width=100% height=500 ng-src=\"/qlik-iframe.html?app=\" id=qlik-frame frameborder=0><p>Your browser does not support iframes.</p></iframe>");
$templateCache.put("app/components/qlikApp/filterPane/filterPane.html","<div class=filter-pane><div class=calc-wrapper><div id=\"{{ filterPane.widgetId }}\" class=filter-pane-injection-point></div></div></div>");
$templateCache.put("app/components/qlikApp/qlikDash/qlikDash.html","<div class=\"qlik-dash container-fluid\"><div class=row><div class=col-md-12 ng-repeat=\"filterWidget in qlikDash.filterBar\"><filter-pane widget-id=\"{{ filterWidget.name }}\" app=$parent.$root.qlikApp></filter-pane></div></div><div class=row ng-style=qlikDash.graphicsRowStyle><qlik-dash-widget ng-repeat=\"visualization in qlikDash.graphics\" ng-style=visualization.style widget-name=visualization.name widget-height=qlikDash.setWidgetHeight(visualization.height) app=$parent.$root.qlikApp></qlik-dash-widget></div></div>");
$templateCache.put("app/components/qlikApp/qlikDash/qlikDashWidget.html","<div class=qlik-dash-widget-wrapper><div id=\"{{ qlikDashWidget.widgetName }}\" ng-style=qlikDashWidget.displayStyle class=qlik-dash-widget></div></div>");
$templateCache.put("app/components/qlikApp/qlikWidgets/qlikWidgets.html","<div><div id=full-size class=main-container ng-if=activeItem><div class=row><div class=\"col-md-12 text-right\"><button class=\"btn btn-primary btn-clear-all\" ng-if=!isKpi ng-click=clearFilters()>{{isForecast ? \'Clear Selections\' : \'Clear All Filters\'}}</button></div></div><div ng-class=\"[\'content-section\', { \'selections-enabled\' : !isKpi },  {\'image-enabled\' : !widget.refuseImage}, {\'csv-enabled\' : !widget.refuseCSV}]\"><div class=qlik-widget><div class=qlik-widget-content><div class=qlik-widget-content-block ng-if=activeItem><div class=qlik-widget-chart qlik-object=activeItem full-size=true></div><div class=pull-right><button class=\"btn btn-default btn-save-image\" aria-label=\"Save to Image\" ng-click=\"saveToImage($event, activeItem)\" ng-if=!refuseImage><i class=\"fa fa-picture-o\" aria-hidden=true></i></button> <button class=\"btn btn-default\" aria-label=\"Return to collection\" ng-click=toggleFullSize($event)><i class=\"fa fa-compress fullsize-toggle\" aria-hidden=true></i></button> <button class=\"btn btn-default btn-export-xlsx\" ng-click=exportCSV(activeItem) aria-label=\"Export to XLSX\" ng-if=!refuseCSV><i class=\"fa fa-file-excel-o\" aria-hidden=true></i></button></div></div></div></div></div></div><div ng-if=!activeItem ng-repeat=\"vis in visualizations\" class=visualization-set><!-- header grey --><div class=row ng-class=\"{\'header-container\': $first, \'sub-header-container\': !$first }\"><div class=col-xs-8><h5>{{::vis.category}}</h5></div></div><!-- main white section --><div class=main-container><div class=content-section><div class=row><div class=\"col-md-12 text-right\"><button class=\"btn btn-primary btn-clear-all\" ng-if=!isKpi ng-click=clearFilters()>{{isForecast ? \'Clear Selections\' : \'Clear All Filters\'}}</button></div></div><div class=row><div ng-repeat=\"widget in vis.widgets\" ng-class=\"[\'qlik-widget\', widget.cssClass, {\'qlik-widget-with-table\': widget.tableId, \'qlik-widget-with-chart\': widget.objectId}]\"><div class=qlik-widget-content><div ng-class=\"[\'qlik-widget-content-block\', {\'image-enabled\' : !widget.refuseImage}, {\'csv-enabled\' : !widget.refuseCSV}]\" ng-if=widget.objectId><div class=qlik-widget-chart qlik-object=widget.objectId></div><div class=pull-right><button class=\"btn btn-default btn-save-image\" aria-label=\"Save to Image\" ng-click=\"saveToImage($event, widget.objectId)\" ng-if=!widget.refuseImage><i class=\"fa fa-picture-o\" aria-hidden=true></i></button> <button class=\"btn btn-default\" aria-label=EXPAND ng-click=\"toggleFullSize($event, widget.objectId, widget.refuseImage, widget.refuseCSV)\"><i class=\"fa fa-expand fullsize-toggle\" aria-hidden=true></i></button> <button class=\"btn btn-default btn-export-xlsx\" ng-click=exportCSV(widget.objectId) ng-if=!widget.refuseCSV><i class=\"fa fa-file-excel-o\" aria-hidden=true></i></button></div></div><div ng-class=\"[\'qlik-widget-content-block\', {\'image-enabled\' : !widget.refuseImage}, {\'csv-enabled\' : !widget.refuseCSV}]\" ng-if=widget.tableId><div class=qlik-widget-table qlik-object=widget.tableId></div><div class=pull-right><button class=\"btn btn-default\" aria-label=EXPAND ng-click=\"toggleFullSize($event, widget.tableId, true, true)\"><i class=\"fa fa-expand fullsize-toggle\" aria-hidden=true></i></button> <button class=\"btn btn-default btn-export-xlsx\" aria-label=\"Export to XLSX\" ng-click=exportCSV(widget.tableId) ng-if=!widget.refuseCSV><i class=\"fa fa-file-excel-o\" aria-hidden=true></i></button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/qlikApp/qlikMaps/qlikMaps.html","<div class=scope><!-- header grey --><div class=row><div class=col-md-8><h5>{{:: qlikMaps.visualization.category | translate}}</h5></div><div class=col-md-4><div class=\"dropdown pull-right\" uib-dropdown=\"\"><a class=\"btn btn-link dropdown-toggle icon-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=true aria-expanded=false>{{qlikMaps.selectedMap.mapName}} <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu cursor-pointer\" role=menu><li ng-repeat=\"map in qlikMaps.maps\"><a ng-click=qlikMaps.switchMap(map)><span>{{:: map.mapName}}</span></a></li></ul></div></div></div><!-- main white section --><div class=content-section><div class=row><div class=col-md-12><button class=\"btn btn-primary control pull-right\" ng-click=qlikMaps.resetMap()>CLEAR ALL FILTERS</button></div></div><div class=\"qlik-map row\" qlik-object=qlikMaps.visualization.mapObjectId></div></div></div>");}]);